export const common = {
  // Navigation
  'nav.features': 'คุณสมบัติ',
  'nav.howItWorks': 'วิธีการทำงาน',
  'nav.pricing': 'ราคา',
  'nav.faq': 'คำถามที่พบบ่อย',
  'nav.aboutUs': 'เกี่ยวกับเรา',
  'nav.getStarted': 'เริ่มต้น',

  // About Us Section
  'aboutUs.badge': "เกี่ยวกับเรา",
  'aboutUs.title': "ทำไม IdeaVerdict ถึงมีอยู่",
  'aboutUs.line1': "ใครก็มีไอเดียได้",
  'aboutUs.line2': "แต่น้อยคนที่ยอมรับว่าไอเดียของตัวเองจะไม่รอด",
  'aboutUs.paragraph1':
    "ไอเดียส่วนใหญ่ไม่ได้ล้มเหลวเพราะผู้ก่อตั้งขาดความกล้า แต่ล้มเหลวเพราะไม่มีใครบอกความจริงให้ทันเวลา IdeaVerdict เติมเต็มช่องว่างนั้น — ความจริงที่ไม่น่าฟังที่เพื่อนของคุณไม่ยอมบอก เราจะบอกเอง",
  'aboutUs.belief1a': "เราไม่ได้ขายการโฆษณาเกินจริง",
  'aboutUs.belief1b': "เราขายสัญญาณจากตลาด",
  'aboutUs.belief2a': "เราไม่ได้ขายแรงบันดาลใจ",
  'aboutUs.belief2b': "เราขายการวิเคราะห์ที่ชัดเจนเกี่ยวกับอุปสงค์ การแข่งขัน และความเป็นไปได้",
  'aboutUs.mission1': "หน้าที่ของเราไม่ใช่การทำให้ไอเดียของคุณดูดี",
  'aboutUs.mission2': "หน้าที่ของเราคือบอกคุณว่ามันดีจริงหรือไม่",
  'aboutUs.analysis':
    "IdeaVerdict ทดสอบไอเดียในสิ่งที่สำคัญจริง — โครงสร้างตลาด อุปสงค์ที่แท้จริง การแข่งขัน เงินทุนที่ต้องใช้ ระยะเวลาสู่รายได้ และความสามารถในการขยายขนาด ไม่มีอารมณ์ ไม่มีการมองโลกในแง่ดี มีแต่การวิเคราะห์",
  'aboutUs.failure1': "ธุรกิจส่วนใหญ่ล้มเหลว",
  'aboutUs.failure2': "ไม่ใช่เพราะคนที่อยู่เบื้องหลังไร้ความสามารถ —",
  'aboutUs.failure3': "แต่เพราะไม่มีใครถามคำถามที่ยากในเวลาที่เหมาะสม",
  'aboutUs.clarity': "เราอยู่ที่นี่เพื่อถามคำถามนั้น",
  'aboutUs.value1': "Direct.",
  'aboutUs.value2': "Honest.",
  'aboutUs.value3': "Fast.",
  'aboutUs.confirm': "If your idea has substance, we back it.",
  'aboutUs.deny': "If it doesn't, we say it to your face.",
  'aboutUs.noApplause': "No applause.",
  'aboutUs.noSugarcoating': "No sugar-coating.",
  'aboutUs.noTheater': "No theatre.",
  'aboutUs.noHype': "Just the verdict.",
  // Hero Section
  'hero.badge': 'คำตัดสินจาก AI ในไม่ถึง 60 วินาที',
  'hero.title1': 'อย่าสร้าง',
  'hero.title2': 'ก่อนที่จะตรวจสอบ',
  'hero.subtitle': 'IdeaVerdict ทดสอบไอเดียของคุณเหมือน VC ที่ขี้สงสัย',
  'hero.subtitleLine2': 'คำตัดสินตรงไปตรงมาในไม่กี่วินาที — ไม่มีการโฆษณาเกินจริง ไม่ประจบประแจง',
  'hero.cta': 'รับคำตัดสินของฉัน',
  'hero.ctaSecondary': 'ดูวิธีการทำงาน',
  'hero.stat1Value': '30',
  'hero.stat1Label': 'เครดิตต่อคำขอ',
  'hero.stat2Value': 'ตั้งแต่ 7',
  'hero.stat2Label': 'มิติการประเมิน',
  'hero.stat3Value': '100%',
  'hero.stat3Label': 'ซื่อสัตย์และเป็นส่วนตัว',

  // Features Section
  'features.title1': 'สร้างขึ้นเพื่อ',
  'features.title2': 'ผู้ก่อตั้งที่',
  'features.title3': 'ต้องการความจริง',
  'features.bullet1.title': 'คำตัดสินตรงไปตรงมาในไม่กี่วินาที',
  'features.bullet1.description':
    'แข็งแกร่ง ปานกลาง หรืออ่อนแอ — พร้อมเหตุผลเบื้องหลังของทุกการประเมิน ไม่มีการปรบมือ ไม่มีการเคลือบน้ำตาล ไม่มีละคร',
  'features.bullet2.title': 'ให้คะแนนจากสิ่งที่สำคัญจริง ๆ',
  'features.bullet2.description':
    'ไอเดียของคุณถูกประเมินจากดีมานด์จริง การแข่งขัน เงินทุนที่ต้องใช้ เวลาในการสร้างรายได้ และความสามารถในการขยาย — ไม่ใช่อารมณ์',
  'features.bullet3.title': 'จากคำตัดสินสู่การลงมือสร้าง',
  'features.bullet3.description':
    'โหมด Builder เปลี่ยนไอเดียที่ผ่านการคัดกรองให้กลายเป็นบรีฟสำหรับนักพัฒนา: ขั้นตอนผู้ใช้ ฟีเจอร์หลัก หมายเหตุทางเทคนิค',

  // How It Works
  'howItWorks.title': 'วิธีการทำงาน',
  'howItWorks.subtitle': 'สี่ขั้นตอนสู่ความชัดเจนเกี่ยวกับช่องทางธุรกิจของคุณ',
  'howItWorks.step1Title': 'เลือกแผน',
  'howItWorks.step1Desc': 'Starter, Pro หรือ Builder – ขึ้นอยู่กับความลึกของการตรวจสอบของคุณ',
  'howItWorks.step2Title': 'ถาม AI',
  'howItWorks.step2Desc': 'ถามคำถามของคุณเกี่ยวกับช่องทาง แต่ละคำขอใช้ 30 เครดิต',
  'howItWorks.step3Title': 'รับคำตัดสินที่ซื่อสัตย์',
  'howItWorks.step3Desc': 'AI ให้คะแนน: ดี ปานกลาง หรือ แย่ ไม่มีการปรุงแต่ง',
  'howItWorks.step4Title': 'ตัดสินใจ',
  'howItWorks.step4Desc': 'ตอนนี้คุณรู้แล้วว่าคุ้มที่จะเดินหน้าต่อไปหรือไม่',

  // Pricing
  'pricing.title': 'ราคา',
  'pricing.subtitle': 'เลือกแผนที่เหมาะกับความลึกของการตรวจสอบของคุณ',
  'pricing.monthly': 'รายเดือน',
  'pricing.yearly': 'รายปี',
  'pricing.yearlyDiscount': 'การสมัครสมาชิกรายปี:',
  'pricing.yearlyDiscountValue': 'ส่วนลด -20%',
  'pricing.perMonth': 'ต่อเดือน',
  'pricing.selectPlan': 'เลือกแผน',
  'pricing.mostPopular': 'ได้รับความนิยมสูงสุด',
  'pricing.footer':
    'ราคาทั้งหมดใน CHF เครดิตจะถูกหักสำหรับการตอบสนองของ AI ที่สำเร็จเท่านั้น',

  
  // Pricing Features
  'pricing.feature1': 'แชทฟรี (ไม่ต้องมีแบบฟอร์ม)',
  'pricing.feature2': 'ตรรกะของตลาดและการให้คะแนนที่ตรงไปตรงมา',
  'pricing.feature3': 'ประวัติการแชทอย่างต่อเนื่อง',
  'pricing.feature4': 'เซสชันการแชทคู่ขนานหลายรายการ',
  'pricing.feature5': 'รองรับหลายภาษาอย่างเต็มรูปแบบ',
  'pricing.feature6': 'การใช้งานตามเครดิต',
  'pricing.feature7': 'การรีเซ็ตรายเดือน',
  'pricing.feature8': 'การวิเคราะห์ตลาด',
  'pricing.feature9': 'สรุป',
  'pricing.feature10': 'จุดแข็ง',
  'pricing.feature11': 'จุดอ่อน',
  'pricing.feature12': 'โอกาส',
  'pricing.feature13': 'ความเสี่ยง',
  'pricing.feature14': 'คำแนะนำ',
  'pricing.feature15': 'ดาวน์โหลด PDF',
  'pricing.feature16': 'ไม่มีการสรุปของนักพัฒนา',
  'pricing.feature17': 'โหมดผู้สร้าง: การสรุปของนักพัฒนา',
  'pricing.feature18': 'สรุปแบบมีโครงสร้าง',

  // Starter Plan
  'pricing.starter.name': 'Starter',
  'pricing.starter.price': '39.90',
  'pricing.starter.description': 'เข้าถึง AI chatbot ช่องทาง',
  'pricing.starter.credits': '2,500 เครดิตต่อเดือน',
  'pricing.starter.feature1': 'สร้างไอเดียช่องทาง',
  'pricing.starter.feature2': 'ปรับแต่งช่องทาง',
  'pricing.starter.feature3': 'ตรวจสอบความเป็นจริงของตลาด',
  'pricing.starter.feature4': 'ประเมินการแข่งขัน',
  'pricing.starter.feature5': 'ประเมินเวลา',
  'pricing.starter.feature6': 'คำตัดสินที่ซื่อสัตย์',
  'pricing.starter.feature7': 'เซสชันส่วนตัว',
  'pricing.starter.feature8': 'ประวัติและการส่งออก',

  // Pro Plan
  'pricing.pro.name': 'Pro',
  'pricing.pro.price': '59.90',
  'pricing.pro.description': 'เข้าถึง AI chatbot ช่องทาง',
  'pricing.pro.credits': '5,000 เครดิตต่อเดือน',
  'pricing.pro.feature1': 'คุณสมบัติ Starter ทั้งหมด',
  'pricing.pro.feature2': 'เครดิตมากขึ้นสำหรับการตรวจสอบแบบเข้มข้น',
  'pricing.pro.feature3': 'ข้อเสนอแนะการปรับปรุง',
  'pricing.pro.feature4': 'ช่องทางทางเลือก',
  'pricing.pro.feature5': 'การวิเคราะห์ตลาดโดยละเอียด',
  'pricing.pro.feature6': 'การสนับสนุนลำดับความสำคัญ',
  'pricing.pro.feature7': 'ตัวกรองขั้นสูง',
  'pricing.pro.feature8': 'เซสชันที่ชื่นชอบ',

  // Builder Plan
  'pricing.builder.name': "Builder",
  'pricing.builder.price': '199',
  'pricing.builder.description': "คุณสมบัติทั้งหมด + โหมด Builder",
  'pricing.builder.credits': "10,000 เครดิตต่อเดือน",
  'pricing.builder.feature1': 'คุณสมบัติ Pro ทั้งหมด',
  'pricing.builder.feature2': 'คำขอ AI ไม่จำกัด',
  'pricing.builder.feature3': 'โหมด Builder: รายละเอียดสำหรับนักพัฒนา',
  'pricing.builder.feature4': 'ภาพรวมโครงการที่มีโครงสร้าง',
  'pricing.builder.feature5': 'การไหลของผู้ใช้และคุณสมบัติหลัก',
  'pricing.builder.feature6': 'บันทึกทางเทคนิค',
  'pricing.builder.feature7': 'กำหนด non-goals',
  'pricing.builder.feature8': 'ขีดจำกัดอัตราการใช้งานที่เหมาะสม',
  'pricing.builder.limitNote': 'ขีดจำกัดการใช้งานที่เหมาะสม',
  'pricing.monthlyReset': 'รีเซ็ตรายเดือน',

  // Modal
  'pricing.modal.selected': 'ที่เลือก',
  'pricing.modal.comingSoon':
    'การลงทะเบียนและการดำเนินการชำระเงินจะพร้อมให้บริการเร็วๆ นี้',
  'pricing.modal.patience':
    'เรากำลังทำงานเพื่อมอบประสบการณ์ที่ปลอดภัยและราบรื่นแก่คุณ โปรดอดใจรอ',
  'pricing.modal.understood': 'เข้าใจแล้ว',

  // FAQ
  'faq.title': "คำถามก่อนที่คุณจะเชื่อคำตัดสิน",
  'faq.subtitle': 'ตอบอย่างซื่อสัตย์และมีวิจารณญาณ',
  'faq.q1': "AI ตรงไปตรงมาแค่ไหนจริง ๆ?",
  'faq.a1': "อย่างโหดร้าย เราปรับมันให้ชี้ไอเดียที่อ่อนแอ ตลาดที่แออัด และตัวเลขที่ไม่สมจริง ถ้าไอเดียของคุณแย่ มันจะบอกตามนั้น",
  'faq.q2': "ฉันจะได้อะไรจากการทดลองใช้ฟรี?",
  'faq.a2': "คำตัดสินเต็มรูปแบบ ทุกตัวชี้วัด ทุกความเสี่ยง ไม่ต้องใช้บัตรเครดิต Builder Report (PDF 25–75 หน้า) ต้องใช้แพ็กเกจแบบเสียเงิน",
  'faq.q3': "ทำไมต้องใช้เครดิตแทนการใช้แบบไม่จำกัด?",
  'faq.a3': "คำตัดสินแต่ละครั้งทำการวิเคราะห์ด้วย AI จริงพร้อมการค้นหาบนเว็บ ซึ่งมีค่าใช้จ่ายสำหรับเรา ระบบเครดิตทำให้ราคายุติธรรม — ผู้ใช้งานหนักจ่ายตามที่ใช้",
  'faq.q4': "ฉันเชื่อถือข้อมูลตลาดได้หรือไม่?",
  'faq.a4': "เราดึงข้อมูลจากแหล่งสาธารณะ เว็บไซต์ของคู่แข่ง และแนวโน้มการค้นหา เราอ้างอิงแหล่งที่มาเท่าที่ทำได้ เราไม่กุตัวเลขขึ้นมา — ถ้าเราไม่รู้ เราก็บอกว่าไม่รู้",
  'faq.q5': "Builder Report คืออะไร?",
  'faq.a5': "PDF ขนาด 25/50/75 หน้า (ขึ้นอยู่กับแพ็กเกจ) ประกอบด้วยสถาปัตยกรรม สแต็กเทคโนโลยี แบบจำลองทางการเงิน แผนการเข้าสู่ตลาด และทะเบียนความเสี่ยง สร้างขึ้นเพื่อให้คุณส่งต่อให้นักพัฒนาหรือนักลงทุนได้ทันที",
  'faq.q6': "ฉันยกเลิกได้ทุกเมื่อหรือไม่?",
  'faq.a6': "ได้ ไม่มีสัญญายาว ยกเลิกได้จากบัญชีของคุณ คุณยังคงเข้าใช้งานได้จนถึงสิ้นสุดรอบที่ชำระเงินแล้ว",
  'faq.q7': "คุณเก็บไอเดียของฉันหรือไม่?",
  'faq.a7': "ใช่ — เก็บไว้ในบัญชีของคุณ เพื่อให้คุณกลับมาดูได้ เราไม่ขายและไม่แชร์ คุณลบได้ทุกเมื่อ",
  'faq.q8': "รองรับภาษาอะไรบ้าง?",
  'faq.a8': "มากกว่ายี่สิบภาษา คำตัดสินจะปรับตามภาษาของคุณโดยอัตโนมัติ",
  'faq.q9': "มีการคืนเงินหรือไม่?",
  'faq.a9': "คืนเงินภายใน 7 วันสำหรับเดือนแรกที่ชำระเงิน หากคุณยังไม่ได้ใช้ Builder Report",
  'faq.q10': "ใครอยู่เบื้องหลัง IdeaVerdict?",
  'faq.a10': "ทีมเล็ก ๆ จากสวิตเซอร์แลนด์ที่เบื่อหน่ายกับการเห็นผู้ก่อตั้งเสียเวลาหลายปีไปกับไอเดียที่ควรถูกทิ้งตั้งแต่สัปดาห์แรก",
  // Footer
  'footer.description':
    'IdeaVerdict ไม่ได้มาเพื่อทำให้คุณรู้สึกดี แต่มาเพื่อช่วยให้คุณตัดสินใจถูก',
  'footer.product': 'ผลิตภัณฑ์',
  'footer.aiAssistant': 'ผู้ช่วย AI',
  'footer.howItWorks': 'วิธีการทำงาน',
  'footer.pricing': 'ราคา',
  'footer.faq': 'คำถามที่พบบ่อย',
  'footer.legal': 'กฎหมาย',
  'footer.privacy': 'ความเป็นส่วนตัว',
  'footer.terms': 'ข้อกำหนด',
  'footer.imprint': 'ข้อมูลผู้ให้บริการ',
  'footer.support': 'การสนับสนุน',
  'footer.contact': 'ติดต่อ',
  'footer.documentation': 'เอกสารประกอบ',
  'footer.copyright': '© 2026 IdeaVerdict สงวนลิขสิทธิ์',

  // AI Assistant
  'aiAssistant.title': 'ผู้ช่วย AI ช่องทาง',
  'aiAssistant.subtitle': 'สอบถามเกี่ยวกับช่องทาง',
  'aiAssistant.welcomeMessage':
    'สวัสดี! อธิบายไอเดียของคุณหรือถามฉันเกี่ยวกับช่องทาง ฉันจะให้การประเมินที่ชัดเจนและซื่อสัตย์แก่คุณ',
  'aiAssistant.demoResponse':
    'นี่เป็นตัวอย่าง หากต้องการการประเมินจาก AI จริง โปรดลงทะเบียนและเลือกแผน',
  'aiAssistant.placeholder': 'อธิบายไอเดียของคุณ...',

  // Header & Sidebar
  'dashboard.header.title': 'แดชบอร์ด',
  'dashboard.header.aiAssistant': 'ผู้ช่วย AI ของคุณ',
  'header.logout': 'ออกจากระบบ',
  'dashboard.sidebar.overview': 'ภาพรวม',
  'dashboard.sidebar.aiChat': 'ผู้ช่วย AI',
  'dashboard.sidebar.newAnalysis': 'ผู้ช่วย AI',
  'dashboard.sidebar.history': 'ประวัติ',
  'dashboard.sidebar.credits': 'เครดิต',
  'dashboard.sidebar.settings': 'การตั้งค่า',

  // Dashboard Overview
  'dashboard.overview.welcome': 'ยินดีต้อนรับกลับ, {{name}}',
  'dashboard.overview.subtitle':
    'นี่คือภาพรวมอย่างรวดเร็วของกิจกรรมของคุณ',

  // Dashboard Stats
  'dashboard.stats.creditsRemaining': 'เครดิตคงเหลือ',
  'dashboard.stats.totalAnalyses': 'การวิเคราะห์ทั้งหมด',
  'dashboard.stats.goodRatings': 'การให้คะแนนเชิงบวก',
  'dashboard.stats.nextReset': 'รีเซ็ตครั้งต่อไปใน',
  'dashboard.stats.days': 'วัน',

  // Quick Actions
  'dashboard.quickActions.title': 'การดำเนินการด่วน',
  'dashboard.quickActions.checkNewIdea': 'ตรวจสอบไอเดีย',
  'dashboard.quickActions.checkNewIdeaDesc':
    'วิเคราะห์ไอเดียธุรกิจที่มีอยู่',
  'dashboard.quickActions.generateIdea': 'สร้างไอเดีย',
  'dashboard.quickActions.generateIdeaDesc':
    'ค้นหาช่องทางที่ทำกำไรใหม่',
  'dashboard.quickActions.builderBriefing': 'รายละเอียดสำหรับนักพัฒนา',
  'dashboard.quickActions.builderBriefingDesc':
    'เปลี่ยนไอเดียให้เป็นรายละเอียดที่พร้อมสำหรับนักพัฒนา',
  'dashboard.quickActions.premiumOnly': 'Builder เท่านั้น',

  // Chat Header
  'chat.title': 'ผู้ช่วย AI ช่องทาง',
  'chat.subtitle':
    'ถามคำถามเกี่ยวกับช่องทาง ฉันประเมินอย่างมีวิจารณญาณและซื่อสัตย์',
  'chat.creditsLabel': 'เครดิต',

  // Chat Welcome
  'chat.welcomeTitle': 'ยินดีต้อนรับสู่ผู้ช่วย AI ช่องทาง',
  'chat.welcomeDesc':
    'อธิบายไอเดียของคุณหรือถามเกี่ยวกับช่องทาง ฉันจะประเมินอย่างซื่อสัตย์: ดี ปานกลาง หรือ แย่',
  'chat.aiWelcome':
    'สวัสดี! อธิบายไอเดียของคุณหรือถามฉันเกี่ยวกับช่องทาง ฉันจะให้การประเมินที่ชัดเจนและซื่อสัตย์แก่คุณ',

  // Chat Suggestions
  'chat.suggestion1': 'ฉันอยากสร้างเครื่องมือ SaaS สำหรับฟรีแลนซ์จัดการใบแจ้งหนี้ นี่เป็นช่องทางที่ดีไหม?',
  'chat.suggestion2': 'หาธุรกิจออนไลน์ที่มีการแข่งขันต่ำที่ฉันเริ่มได้ด้วย $500 โดยไม่ต้องเขียนโค้ด',
  'chat.suggestion3': 'ประเมินสิ่งนี้: แอปวางแผนมื้ออาหาร AI สำหรับพ่อแม่ที่ยุ่งที่มีข้อจำกัดด้านอาหาร',
  'chat.suggestion4': 'ฉันอยากขายเทมเพลตดิจิทัลบน Etsy สำหรับเจ้าของธุรกิจขนาดเล็ก วิเคราะห์ช่องทางนี้อย่างซื่อสัตย์',

  // Chat Actions
  'chat.newConversation': 'บทสนทนาใหม่',
  'chat.today': 'วันนี้',
  'chat.yesterday': 'เมื่อวาน',
  'chat.thisWeek': 'สัปดาห์นี้',
  'chat.thisMonth': 'เดือนนี้',
  'chat.older': 'เก่ากว่า',
  'chat.messages': 'ข้อความ',
  'chat.renameConversation': 'เปลี่ยนชื่อ',
  'chat.deleteConversation': 'ลบ',
  'chat.cancel': 'ยกเลิก',
  'chat.rename': 'เปลี่ยนชื่อ',
  'chat.delete': 'ลบ',
  'chat.favorite': 'เพิ่มรายการโปรด',
  'chat.unfavorite': 'ลบรายการโปรด',
  'chat.searchSessions': 'ค้นหาบทสนทนา...',
  'chat.noResults': 'ไม่พบผลลัพธ์',
  'chat.noSessions': 'ยังไม่มีบทสนทนา',
  'chat.enterNewName': 'ป้อนชื่อใหม่...',
  'chat.deleteConfirmMessage':
    'คุณแน่ใจหรือไม่ที่จะลบบทสนทนานี้? การดำเนินการนี้ไม่สามารถยกเลิกได้',

  // Chat Input & Errors
  'chat.inputPlaceholder': 'พิมพ์คำถามของคุณ… (ใช้ 30 เครดิต)',
  'chat.send': 'ส่ง',
  'chat.voice': 'พูด',
  'chat.listeningPlaceholder': 'ฉันกำลังฟัง... พูดเลย',
  'chat.stopListening': 'หยุดฟัง',
  'chat.recording': 'กำลังบันทึก...',
  'chat.speechNotSupported': 'เบราว์เซอร์ของคุณไม่รองรับการรู้จำเสียง',
  'chat.microphonePermissionDenied': 'ปฏิเสธการเข้าถึงไมโครโฟน โปรดอนุญาตในการตั้งค่าเบราว์เซอร์',
  'chat.errorNotEnoughCredits':
    'เครดิตไม่เพียงพอ โปรดอัปเกรดแผนของคุณหรือรอการรีเซ็ตครั้งต่อไป',
  'chat.errorAiFailed': 'การตอบสนองของ AI ล้มเหลว ไม่มีการหักเครดิต',
  'chat.errorRateLimit': 'คำขอมากเกินไป โปรดรอสักครู่',

  // Ratings
  'rating.good': 'ดี',
  'rating.medium': 'ปานกลาง',
  'rating.bad': 'แย่',

  // Auth Page
  'auth.branding.headline1': 'ไม่ใช่ทุกไอเดียที่ดี',
  'auth.branding.headline2': 'เราบอกคุณอย่างซื่อสัตย์',
  'auth.branding.subtitle':
    'AI ตัดสินใจสำหรับช่องทางธุรกิจ ชัดเจน มีวิจารณญาณ ไม่มีการปรุงแต่ง',
  'auth.benefits.privacy.title': 'เป็นส่วนตัว 100%',
  'auth.benefits.privacy.desc':
    'ไอเดียของคุณจะถูกเก็บเป็นส่วนตัวและปลอดภัยอย่างสมบูรณ์',
  'auth.benefits.honest.title': 'AI ที่ซื่อสัตย์',
  'auth.benefits.honest.desc':
    'ไม่มีการปรุงแต่ง – แค่ข้อเสนอแนะที่ชัดเจนและมีวิจารณญาณ',
  'auth.benefits.fast.title': 'ผลลัพธ์รวดเร็ว',
  'auth.benefits.fast.desc': 'รับความชัดเจนเกี่ยวกับช่องทางของคุณในไม่กี่นาที',
  'auth.trust.users': 'ผู้ใช้ที่ใช้งาน',
  'auth.trust.ideas': 'ไอเดียที่วิเคราะห์',
  'auth.trust.rating': 'คะแนนผู้ใช้',
  'auth.login.title': 'เข้าสู่ระบบ',
  'auth.login.headline': 'ยินดีต้อนรับกลับ',
  'auth.login.subtitle': 'ลงชื่อเข้าใช้เพื่อเดินทางต่อ',
  'auth.login.forgotPassword': 'ลืมรหัสผ่าน?',
  'auth.login.submit': 'ลงชื่อเข้าใช้',
  'auth.login.noAccount': 'ยังไม่มีบัญชี?',
  'auth.login.signUp': 'สมัครสมาชิก',
  'auth.register.title': 'ลงทะเบียน',
  'auth.register.headline': 'สร้างบัญชีของคุณ',
  'auth.register.subtitle':
    'เริ่มวิเคราะห์ไอเดียธุรกิจของคุณวันนี้',
  'auth.register.submit': 'สร้างบัญชี',
  'auth.register.hasAccount': 'มีบัญชีอยู่แล้ว?',
  'auth.register.signIn': 'ลงชื่อเข้าใช้',
  'auth.fields.name': 'ชื่อเต็ม',
  'auth.fields.email': 'ที่อยู่อีเมล',
  'auth.fields.password': 'รหัสผ่าน',
  'auth.fields.confirmPassword': 'ยืนยันรหัสผ่าน',
  'auth.fields.selectPlan': 'เลือกแผนของคุณ',
  'auth.fields.testCode': 'เข้าสู่ระบบและทดลองใช้ฟรี',
  'auth.placeholders.name': 'ป้อนชื่อของคุณ',
  'auth.placeholders.email': 'ป้อนอีเมลของคุณ',
  'auth.placeholders.password': 'ป้อนรหัสผ่านของคุณ',
  'auth.placeholders.confirmPassword': 'ยืนยันรหัสผ่านของคุณ',
  'auth.placeholders.testCode': 'ป้อนรหัสทดสอบ',
  'auth.terms.accept': 'ฉันยอมรับ',
  'auth.terms.terms': 'ข้อกำหนดและเงื่อนไข',
  'auth.privacy.accept': 'ฉันยอมรับ',
  'auth.privacy.policy': 'นโยบายความเป็นส่วนตัว',
  'auth.errors.nameRequired': 'ต้องระบุชื่อ',
  'auth.errors.emailRequired': 'ต้องระบุอีเมล',
  'auth.errors.emailInvalid': 'โปรดป้อนอีเมลที่ถูกต้อง',
  'auth.errors.passwordRequired': 'ต้องระบุรหัสผ่าน',
  'auth.errors.passwordLength': 'รหัสต้องมีความยาวอย่างน้อย 8 ตัวอักษร',
  'auth.errors.passwordMismatch': 'รหัสผ่านไม่ตรงกัน',
  'auth.errors.invalidCode': 'รหัสไม่ถูกต้องหรือหมดอายุ',
  'auth.errors.registrationCodeOnly': 'รหัสนี้สำหรับการลงทะเบียนเท่านั้น',
  'auth.errors.verificationFailed': 'เกิดข้อผิดพลาดในการตรวจสอบรหัส โปรดลองอีกครั้ง',
  'auth.loading': 'โปรดรอ...',
  'auth.or': 'หรือดำเนินการต่อด้วย',
  'auth.social.google': 'ดำเนินการต่อด้วย Google',
  'auth.social.apple': 'ดำเนินการต่อด้วย Apple',
  'auth.actions.verify': 'ยืนยัน',
  'auth.testCode.activated': 'เปิดใช้งานรหัสทดสอบแล้ว!',
  'auth.testCode.days': 'วัน',
  'auth.testCode.months': 'เดือน',
  'auth.testCode.freeAccess': 'เข้าถึงฟรี',
  'auth.testCode.credits': 'เครดิต',

  // Email Verification
  'auth.verification.title': 'ยืนยันอีเมล',
  'auth.verification.headline': 'ตรวจสอบกล่องจดหมายของคุณ',
  'auth.verification.subtitle': 'เราส่งรหัสยืนยันไปที่:',
  'auth.verification.codeLabel': 'รหัสยืนยัน',
  'auth.verification.codePlaceholder': 'ป้อนรหัส 6 หลัก',
  'auth.verification.submit': 'ยืนยันอีเมล',
  'auth.verification.resend': 'ส่งรหัสอีกครั้ง',
  'auth.verification.resendIn': 'ส่งอีกครั้งใน',
  'auth.verification.seconds': 'วินาที',
  'auth.verification.success': 'ยืนยันอีเมลสำเร็จ!',
  'auth.verification.error': 'รหัสไม่ถูกต้อง โปรดลองอีกครั้ง',
  'auth.verification.expired': 'รหัสหมดอายุ โปรดขอรหัสใหม่',
  'auth.verification.sent': 'ส่งรหัสใหม่แล้ว!',
  'auth.verification.checkSpam':
    'ไม่ได้รับ? ตรวจสอบโฟลเดอร์สแปม',

  // Forgot Password
  'auth.forgot.title': 'ลืมรหัสผ่าน',
  'auth.forgot.headline': 'รีเซ็ตรหัสผ่านของคุณ',
  'auth.forgot.subtitle':
    'ป้อนที่อยู่อีเมลของคุณแล้วเราจะส่งลิงก์รีเซ็ตให้คุณ',
  'auth.forgot.submit': 'ส่งลิงก์รีเซ็ต',
  'auth.forgot.backToLogin': 'กลับไปที่เข้าสู่ระบบ',
  'auth.forgot.success': 'ส่งอีเมลแล้ว!',
  'auth.forgot.successMessage':
    'เราได้ส่งอีเมลพร้อมคำแนะนำในการรีเซ็ตรหัสผ่านของคุณ',
  'auth.forgot.checkInbox': 'ตรวจสอบกล่องจดหมายของคุณ',

  // Reset Password
  'auth.reset.title': 'รหัสผ่านใหม่',
  'auth.reset.headline': 'ตั้งรหัสผ่านใหม่',
  'auth.reset.subtitle': 'ป้อนรหัสผ่านใหม่ของคุณ',
  'auth.reset.newPassword': 'รหัสผ่านใหม่',
  'auth.reset.confirmNewPassword': 'ยืนยันรหัสผ่านใหม่',
  'auth.reset.submit': 'เปลี่ยนรหัสผ่าน',
  'auth.reset.success': 'เปลี่ยนรหัสผ่านสำเร็จ!',
  'auth.reset.successMessage':
    'ตอนนี้คุณสามารถลงชื่อเข้าใช้ด้วยรหัสผ่านใหม่ของคุณ',
  'auth.reset.loginNow': 'ลงชื่อเข้าใช้ตอนนี้',

  // Legal Pages
  'legal.backToAuth': 'กลับไปที่เข้าสู่ระบบ',
  'legal.allRightsReserved': 'สงวนลิขสิทธิ์',

  // Terms Page
  'legal.terms.title': 'ข้อกำหนดและเงื่อนไข',
  'legal.terms.lastUpdated': 'อัปเดตล่าสุด',
  'legal.terms.section1.title': '1. ขอบเขต',
  'legal.terms.section1.content':
    'ข้อกำหนดและเงื่อนไขเหล่านี้ใช้กับสัญญาทั้งหมดระหว่าง NicheFinder (ต่อไปนี้เรียกว่า "ผู้ให้บริการ") และผู้ใช้ (ต่อไปนี้เรียกว่า "ลูกค้า") เกี่ยวกับการใช้แพลตฟอร์มการวิเคราะห์ช่องทางที่ขับเคลื่อนด้วย AI',
  'legal.terms.section2.title': '2. คำอธิบายบริการ',
  'legal.terms.section2.content':
    'ผู้ให้บริการเสนอแพลตฟอร์มที่ขับเคลื่อนด้วย AI ซึ่งวิเคราะห์และประเมินไอเดียธุรกิจและช่องทาง บริการรวมถึง:',
  'legal.terms.section2.item1': 'การวิเคราะห์ไอเดียธุรกิจด้วย AI',
  'legal.terms.section2.item2': 'การประเมินศักยภาพของตลาดและการแข่งขัน',
  'legal.terms.section2.item3': 'การสร้างข้อเสนอแนะช่องทาง',
  'legal.terms.section2.item4': 'การสร้างรายละเอียดสำหรับนักพัฒนา (แพ็คเกจ Builder)',
  'legal.terms.section3.title': '3. การสรุปสัญญาและการลงทะเบียน',
  'legal.terms.section3.content':
    'สัญญาจะสรุปผ่านการลงทะเบียนบนแพลตฟอร์มและการเลือกแพ็คเกจ ลูกค้ายืนยัน:',
  'legal.terms.section3.item1': 'การบรรลุนิติภาวะและมีความสามารถทางกฎหมายอย่างเต็มที่',
  'legal.terms.section3.item2': 'การให้ข้อมูลที่เป็นความจริงระหว่างการลงทะเบียน',
  'legal.terms.section3.item3': 'การจัดเก็บข้อมูลรับรองการเข้าถึงอย่างปลอดภัย',
  'legal.terms.section4.title': '4. เครดิตและการเรียกเก็บเงิน',
  'legal.terms.section4.content':
    'การใช้คุณสมบัติ AI ขึ้นอยู่กับระบบเครดิต การสอบถาม AI แต่ละครั้งใช้ 30 เครดิต เครดิตจะถูกหักเมื่อได้รับการตอบสนองที่สำเร็จเท่านั้น เครดิตที่ไม่ได้ใช้จะหมดอายุเมื่อสิ้นสุดรอบการเรียกเก็บเงินและไม่ได้รับคืน',
  'legal.terms.section5.title': '5. ข้อจำกัดความรับผิดชอบ',
  'legal.terms.section5.content':
    'การประเมินของ AI ทำหน้าที่เป็นเพียงเครื่องมือช่วยในการตัดสินใจและไม่รับประกันความสำเร็จทางธุรกิจ ผู้ให้บริการไม่รับผิดชอบต่อการตัดสินใจที่เกิดขึ้นจากการวิเคราะห์ของ AI ความรับผิดชอบต่อเจตนาและความประมาทเลินเล่ออย่างร้ายแรงยังคงอยู่',
  'legal.terms.section6.title': '6. การปกป้องข้อมูลและการรักษาความลับ',
  'legal.terms.section6.content':
    'ไอเดียธุรกิจที่ส่งทั้งหมดจะถูกเก็บเป็นความลับและไม่แบ่งปันกับบุคคลที่สาม การประมวลผลข้อมูลส่วนบุคคลเป็นไปตามนโยบายความเป็นส่วนตัวและกฎหมายคุ้มครองข้อมูลที่เกี่ยวข้อง',
  'legal.terms.section7.title': '7. การยกเลิก',
  'legal.terms.section7.content':
    'ลูกค้าสามารถยกเลิกการสมัครสมาชิกได้ตลอดเวลาเมื่อสิ้นสุดรอบการเรียกเก็บเงินปัจจุบัน ในกรณีที่ละเมิดข้อกำหนดเหล่านี้ ผู้ให้บริการขอสงวนสิทธิ์ในการบล็อกการเข้าถึงแพลตฟอร์ม',
  'legal.terms.section8.title': '8. บทบัญญัติสุดท้าย',
  'legal.terms.section8.content':
    'กฎหมายสวิสมีผลบังคับใช้ สถานที่พิจารณาคดีคือซูริก สวิตเซอร์แลนด์ หากบทบัญญัติแต่ละข้อของข้อกำหนดเหล่านี้ไม่ถูกต้อง ความถูกต้องของบทบัญญัติที่เหลือยังคงไม่ได้รับผลกระทบ',
  'legal.terms.contact.title': 'มีคำถามเกี่ยวกับข้อกำหนดหรือไม่?',
  'legal.terms.contact.content':
    'หากคุณมีคำถามเกี่ยวกับข้อกำหนดและเงื่อนไขเหล่านี้ โปรดติดต่อเราที่:',

  // Privacy Page
  'legal.privacy.title': 'นโยบายความเป็นส่วนตัว',
  'legal.privacy.section1.title': '1. ผู้ควบคุมข้อมูล',
  'legal.privacy.section1.content':
    'ผู้ควบคุมข้อมูลสำหรับเว็บไซต์นี้คือ NicheFinder, Zurich, Switzerland เราปฏิบัติต่อการปกป้องข้อมูลส่วนบุคคลของคุณอย่างจริงจังและปฏิบัติต่อข้อมูลส่วนบุคคลของคุณอย่างเป็นความลับและเป็นไปตามกฎระเบียบการคุ้มครองข้อมูลตามกฎหมาย',
  'legal.privacy.section2.title': '2. ข้อมูลที่รวบรวม',
  'legal.privacy.section2.content':
    'เรารวบรวมและประมวลผลข้อมูลส่วนบุคคลดังต่อไปนี้:',
  'legal.privacy.section2.item1':
    'ข้อมูลการลงทะเบียน: ชื่อ, ที่อยู่อีเมล, รหัสผ่าน (เข้ารหัส)',
  'legal.privacy.section2.item2':
    'ข้อมูลการใช้งาน: ที่อยู่ IP, ประเภทเบราว์เซอร์, เวลาที่เข้าถึง',
  'legal.privacy.section2.item3':
    'ไอเดียธุรกิจและการสอบถามช่องทาง (จัดเก็บโดยไม่ระบุชื่อ)',
  'legal.privacy.section2.item4':
    'ข้อมูลการชำระเงิน (ผ่านผู้ให้บริการบุคคลที่สามที่ปลอดภัย)',
  'legal.privacy.section3.title': '3. วัตถุประสงค์ของการประมวลผลข้อมูล',
  'legal.privacy.section3.content':
    'ข้อมูลของคุณถูกใช้เพื่อวัตถุประสงค์ดังต่อไปนี้:',
  'legal.privacy.section3.item1':
    'การให้บริการและการปรับปรุงบริการ AI ของเรา',
  'legal.privacy.section3.item2':
    'การจัดการบัญชีและการรับรองความถูกต้อง',
  'legal.privacy.section3.item3':
    'การเรียกเก็บเงินและการประมวลผลการชำระเงิน',
  'legal.privacy.section4.title': '4. ความปลอดภัยของข้อมูล',
  'legal.privacy.section4.content':
    'เราใช้มาตรการรักษาความปลอดภัยทางเทคนิคและองค์กรเพื่อปกป้องข้อมูลของคุณจากการถูกจัดการ สูญหาย ทำลาย หรือการเข้าถึงโดยไม่ได้รับอนุญาต การถ่ายโอนข้อมูลทั้งหมดถูกเข้ารหัสผ่าน SSL/TLS',
  'legal.privacy.section5.title': '5. การรักษาความลับของไอเดียธุรกิจของคุณ',
  'legal.privacy.section5.content':
    'ไอเดียธุรกิจและการสอบถามช่องทางที่คุณส่งจะถูกเก็บเป็นความลับอย่างเคร่งครัด จะไม่ถูกแบ่งปันกับบุคคลที่สาม ไม่ถูกใช้เพื่อวัตถุประสงค์ในการฝึกอบรม และสามารถลบได้ทั้งหมดตามคำขอ ไอเดียของคุณเป็นของคุณ',
  'legal.privacy.section6.title': '6. สิทธิ์ของคุณ',
  'legal.privacy.section6.content':
    'คุณมีสิทธิ์ดังต่อไปนี้เกี่ยวกับข้อมูลส่วนบุคคลของคุณ:',
  'legal.privacy.section6.item1': 'สิทธิ์ในการเข้าถึงข้อมูลที่เก็บไว้',
  'legal.privacy.section6.item2': 'สิทธิ์ในการแก้ไขข้อมูลที่ไม่ถูกต้อง',
  'legal.privacy.section6.item3': 'สิทธิ์ในการลบข้อมูลของคุณ',
  'legal.privacy.section6.item4': 'สิทธิ์ในการโอนย้ายข้อมูล',
  'legal.privacy.section7.title': '7. คุกกี้',
  'legal.privacy.section7.content':
    'เว็บไซต์ของเราใช้คุกกี้ที่จำเป็นทางเทคนิคสำหรับการรับรองความถูกต้องและการจัดการเซสชันเท่านั้น เราไม่ใช้คุกกี้ติดตามหรือเครื่องมือวิเคราะห์ของบุคคลที่สามโดยไม่ได้รับความยินยอมอย่างชัดแจ้งจากคุณ',
  'legal.privacy.section8.title': '8. การเปลี่ยนแปลงนโยบายความเป็นส่วนตัวนี้',
  'legal.privacy.section8.content':
    'เราขอสงวนสิทธิ์ในการปรับนโยบายความเป็นส่วนตัวนี้เพื่อให้เป็นไปตามข้อกำหนดทางกฎหมายที่เปลี่ยนแปลงไปหรือเมื่อมีการเปลี่ยนแปลงบริการ เวอร์ชันปัจจุบันสามารถพบได้บนหน้านี้เสมอ',
  'legal.privacy.contact.title': 'มีคำถามเกี่ยวกับความเป็นส่วนตัวหรือไม่?',
  'legal.privacy.contact.content':
    'หากคุณมีคำถามเกี่ยวกับการประมวลผลข้อมูลส่วนบุคคลของคุณ โปรดติดต่อเราที่:',

  'auth.passwordStrength.label': 'ความแข็งแกร่งของรหัสผ่าน',
  'auth.passwordStrength.weak': 'อ่อน',
  'auth.passwordStrength.medium': 'ปานกลาง',
  'auth.passwordStrength.strong': 'แข็งแรง',
  'auth.passwordStrength.veryStrong': 'แข็งแรงมาก',
  'auth.passwordStrength.minLength': 'อย่างน้อย 8 ตัวอักษร',
  'auth.passwordStrength.uppercase': 'ตัวพิมพ์ใหญ่',
  'auth.passwordStrength.number': 'ตัวเลข',
  'auth.passwordStrength.special': 'อักขระพิเศษ',

  trial: {
    subtitle: 'ทดลองใช้ฟรี',
    upgrade: 'อัปเกรดตอนนี้',
    creditsRemaining: 'เครดิตคงเหลือ',
    inputHint: 'เวอร์ชันทดลองใช้ - ไม่มีประวัติบทสนทนา',
    banner: {
      title: 'ทดลองใช้ 7 วัน',
      remaining: 'เหลือ {{days}} วัน',
      credits: 'เครดิตที่พร้อมใช้งาน',
      upgradeNow: 'อัปเกรดตอนนี้',
    },
    welcome: {
      title: 'ยินดีต้อนรับสู่การทดลองใช้ฟรี!',
      desc: 'ทดสอบผู้ช่วย AI ของเราฟรี 7 วัน พร้อม 100 เครดิต ถามคำถามและค้นพบความเป็นไปได้!',
    },
    info: {
      title: 'ข้อจำกัดการทดลองใช้',
      credits: '100 เครดิตเป็นเวลา 7 วัน',
      noHistory: 'ไม่มีประวัติบทสนทนา',
      noSettings: 'คุณสมบัติจำกัด',
      upgrade: 'อัปเกรดเพื่อคุณสมบัติเต็มรูปแบบ',
    },
  },

  // ─── Settings Page ────────────────────────────────────────────────────────────
  'settings.title': 'การตั้งค่า',
  'settings.subtitle': 'จัดการบัญชีและการตั้งค่าของคุณ',
  'settings.backToOverview': 'กลับไปที่ภาพรวม',
  'settings.subscriptionLink': 'การสมัครสมาชิกและการเรียกเก็บเงิน',
  'settings.saved': 'บันทึกการเปลี่ยนแปลงสำเร็จ',
  'settings.changesSaved': 'บันทึกการเปลี่ยนแปลงแล้ว',
  'settings.saveChanges': 'บันทึกการเปลี่ยนแปลง',
  'settings.dataExported': 'ส่งออกข้อมูลสำเร็จ',

  // Tabs
  'settings.tabs.profile': 'โปรไฟล์',
  'settings.tabs.preferences': 'การตั้งค่า',
  'settings.tabs.notifications': 'การแจ้งเตือน',
  'settings.tabs.account': 'บัญชีและแผน',

  // Profile
  'settings.profile.changePhoto': 'เปลี่ยนรูปภาพ',
  'settings.profile.photoHint': 'JPG, PNG หรือ GIF (สูงสุด 2MB)',
  'settings.profile.uploading': 'กำลังอัปโหลด...',
  'settings.profile.photoUpdated': 'อัปเดตรูปโปรไฟล์แล้ว!',
  'settings.profile.name': 'ชื่อ',
  'settings.profile.email': 'อีเมล',
  'settings.profile.phone': 'โทรศัพท์',
  'settings.profile.changePassword': 'เปลี่ยนรหัสผ่าน',
  'settings.profile.currentPassword': 'รหัสผ่านปัจจุบัน',
  'settings.profile.newPassword': 'รหัสผ่านใหม่',
  'settings.profile.confirmPassword': 'ยืนยันรหัสผ่าน',

  // Preferences
  'settings.preferences.language': 'ภาษา',
  'settings.preferences.chooseLanguage': 'เลือกภาษา',
  'settings.preferences.timezone': 'เขตเวลา',
  'settings.preferences.currency': 'สกุลเงิน',

  // Notifications
  'settings.notifications.emailTitle': 'การแจ้งเตือนทางอีเมล',
  'settings.notifications.email.analysis': 'การวิเคราะห์เสร็จสมบูรณ์',
  'settings.notifications.email.analysisDesc': 'รับอีเมลเมื่อการวิเคราะห์ของคุณพร้อม',
  'settings.notifications.email.credits': 'อัปเดตเครดิต',
  'settings.notifications.email.creditsDesc': 'การแจ้งเตือนเกี่ยวกับเครดิตและการรีเซ็ต',
  'settings.notifications.email.billing': 'ใบแจ้งหนี้และการชำระเงิน',
  'settings.notifications.email.billingDesc': 'การแจ้งเตือนเกี่ยวกับใบแจ้งหนี้และการเปลี่ยนแปลงแผน',
  'settings.notifications.email.newsletter': 'จดหมายข่าว',
  'settings.notifications.email.newsletterDesc': 'เคล็ดลับ อัปเดตและคุณสมบัติใหม่',
  'settings.notifications.pushTitle': 'การแจ้งเตือนแบบ Push',
  'settings.notifications.push.analysis': 'การวิเคราะห์เสร็จสมบูรณ์',
  'settings.notifications.push.analysisDesc': 'การแจ้งเตือนทางเบราว์เซอร์เมื่อการวิเคราะห์พร้อม',
  'settings.notifications.push.credits': 'คำเตือนเครดิต',
  'settings.notifications.push.creditsDesc': 'คำเตือนเมื่อยอดเครดิตเหลือน้อย',

  // Account
  'settings.account.currentSubscription': 'การสมัครสมาชิกปัจจุบัน',
  'settings.account.plan': 'แผน',
  'settings.account.price': 'ราคา',
  'settings.account.nextBilling': 'การเรียกเก็บเงินครั้งต่อไป',
  'settings.account.manageSubscription': 'จัดการการสมัครสมาชิกและการชำระเงิน',
  'settings.account.dataPrivacy': 'ข้อมูลและความเป็นส่วนตัว',
  'settings.account.exportData': 'ส่งออกข้อมูล',
  'settings.account.deleteAccount': 'ลบบัญชี',

  // Delete Modal
  'settings.deleteModal.title': 'ลบบัญชี?',
  'settings.deleteModal.subtitle': 'ข้อมูลทั้งหมดจะถูกลบอย่างถาวร',
  'settings.deleteModal.warning1': 'การวิเคราะห์และข้อมูลทั้งหมดจะถูกลบ',
  'settings.deleteModal.warning2': 'การสมัครสมาชิกที่ใช้งานอยู่จะถูกยกเลิกทันที',
  'settings.deleteModal.warning3': 'ไม่สามารถขอคืนเงินได้',
  'settings.deleteModal.confirmLabel': 'พิมพ์ "{{word}}" เพื่อยืนยัน *',
  'settings.deleteModal.cancel': 'ยกเลิก',
  'settings.deleteModal.confirm': 'ลบบัญชี',

  // ─── Subscription & Billing ─────────────────────────────
  'sub.backToOverview': 'กลับไปที่ภาพรวม',
  'sub.settings': 'การตั้งค่า',
  'sub.title': 'การสมัครสมาชิกและการเรียกเก็บเงิน',
  'sub.subtitle': 'จัดการการสมัครสมาชิก วิธีการชำระเงินและใบแจ้งหนี้ของคุณ',
  'sub.tab.overview': 'ภาพรวม',
  'sub.tab.payment': 'วิธีการชำระเงิน',
  'sub.tab.billing': 'ที่อยู่สำหรับออกใบแจ้งหนี้',
  'sub.tab.history': 'ประวัติการชำระเงิน',
  'sub.memberSince': 'เป็นสมาชิกตั้งแต่',
  'sub.perMonth': 'ต่อเดือน',
  'sub.baseCHF': '(CHF {{amount}} พื้นฐาน)',
  'sub.nextBilling': 'การเรียกเก็บเงินครั้งต่อไป',
  'sub.creditsUsed': 'เครดิตที่ใช้',
  'sub.paymentMethod': 'วิธีการชำระเงิน',
  'sub.creditUsage': 'การใช้งานเครดิต',
  'sub.changePlan': 'เปลี่ยนแผน',
  'sub.reactivate': 'เปิดใช้งานอีกครั้ง',
  'sub.cancelSub': 'ยกเลิกการสมัครสมาชิก',
  'sub.manageCards': 'จัดการบัตร',
  'sub.downloadInvoices': 'ดาวน์โหลดใบแจ้งหนี้',
  'sub.invoicesAvailable': 'มีใบแจ้งหนี้ {{count}} ฉบับเป็น PDF',
  'sub.accountSettings': 'การตั้งค่าบัญชี',
  'sub.profileNotifications': 'โปรไฟล์, การแจ้งเตือนและอื่นๆ',
  // Prices in EUR info
  'sub.eurInfo': 'ราคาที่แสดงเป็น',
  'sub.eurLabel': 'ยูโร',
  'sub.eurRate': 'อัตรา:',
  'sub.currentRate': 'อัตราปัจจุบัน',
  // Payment Methods
  'sub.savedCards': 'บัตรที่บันทึกไว้',
  'sub.newCard': 'บัตรใหม่',
  'sub.default': 'ค่าเริ่มต้น',
  'sub.setDefault': 'ตั้งเป็นค่าเริ่มต้น',
  'sub.validUntil': 'ใช้ได้จนถึง',
  'sub.noCards': 'ไม่มีบัตรที่บันทึกไว้',
  'sub.addFirstCard': 'เพิ่มบัตรแรก',
  'sub.securePayments': 'การชำระเงินที่ปลอดภัย',
  'sub.securePaymentsDesc': 'ข้อมูลการชำระเงินทั้งหมดถูกส่งแบบเข้ารหัสและจัดเก็บอย่างปลอดภัยกับผู้ให้บริการชำระเงินของเรา เราไม่เก็บหมายเลขบัตรทั้งหมด',
  // Billing Address
  'sub.billingAddress': 'ที่อยู่สำหรับออกใบแจ้งหนี้',
  'sub.edit': 'แก้ไข',
  'sub.name': 'ชื่อ',
  'sub.streetAddress': 'ถนนและหมายเลข',
  'sub.zip': 'รหัสไปรษณีย์',
  'sub.city': 'เมือง',
  'sub.country': 'ประเทศ',
  'sub.address': 'ที่อยู่',
  'sub.save': 'บันทึก',
  'sub.cancel': 'ยกเลิก',
  'sub.country.switzerland': 'สวิตเซอร์แลนด์',
  'sub.country.germany': 'เยอรมนี',
  'sub.country.austria': 'ออสเตรีย',
  'sub.country.netherlands': 'เนเธอร์แลนด์',
  'sub.country.belgium': 'เบลเยียม',
  // Payment History
  'sub.paymentHistory': 'ประวัติการชำระเงิน',
  'sub.allInvoicesPDF': 'ดาวน์โหลดใบแจ้งหนี้ทั้งหมดเป็น PDF พร้อมโลโก้',
  'sub.downloadAll': 'ดาวน์โหลดทั้งหมด',
  'sub.eurInvoiceNote': 'ใบแจ้งหนี้จะออกใน CHF เสมอ จำนวนเงิน EUR ที่แสดงมีไว้เพื่อการอ้างอิงเท่านั้น',
  'sub.date': 'วันที่',
  'sub.description': 'คำอธิบาย',
  'sub.net': 'สุทธิ',
  'sub.vat': 'ภาษีมูลค่าเพิ่ม',
  'sub.total': 'รวม',
  'sub.status': 'สถานะ',
  'sub.pdf': 'PDF',
  'sub.invoices': 'ใบแจ้งหนี้',
  'sub.totalAmount': 'จำนวนเงินรวม',
  // Change Plan Modal
  'sub.changePlanTitle': 'เปลี่ยนแผน',
  'sub.current': 'ปัจจุบัน',
  'sub.month': '/เดือน',
  'sub.showLess': 'แสดงน้อยลง',
  'sub.showMore': '+{{count}} เพิ่มเติม',
  'sub.switchPlan': 'เปลี่ยนแผน',
  'sub.eurPriceNote': 'ราคาที่แสดงใน EUR ({{note}}) การเรียกเก็บเงินเป็น CHF',
  // Cancel Modal
  'sub.cancelTitle': 'ยกเลิกการสมัครสมาชิกจริงหรือ?',
  'sub.cancelIrreversible': 'การดำเนินการนี้ไม่สามารถยกเลิกได้',
  'sub.cancelWarning1': 'เครดิตที่เหลือทั้งหมดจะหมดอายุ',
  'sub.cancelWarning2': 'ดาวน์เกรดเป็นแผนฟรี',
  'sub.cancelWarning3': 'สูญเสียคุณสมบัติพรีเมียมทั้งหมด',
  'sub.pauseInstead': 'ทางเลือก: หยุดการสมัครสมาชิกชั่วคราว?',
  'sub.pauseDesc': 'หยุดการสมัครสมาชิกของคุณชั่วคราวและเก็บข้อมูลของคุณไว้',
  'sub.preferPause': 'ต้องการหยุดชั่วคราว',
  'sub.cancelReason': 'เหตุผลในการยกเลิก',
  'sub.selectReason': 'โปรดเลือก...',
  'sub.reason.tooExpensive': 'แพงเกินไป',
  'sub.reason.notUsing': 'ไม่ได้ใช้เพียงพอ',
  'sub.reason.missingFeatures': 'คุณสมบัติที่ขาดหายไป',
  'sub.reason.foundAlternative': 'พบทางเลือกอื่น',
  'sub.reason.other': 'อื่นๆ',
  'sub.confirmType': 'การยืนยัน: พิมพ์ "CANCEL" *',
  'sub.cancelNow': 'ยกเลิกตอนนี้',
  // Add Card Modal
  'sub.addCardTitle': 'เพิ่มบัตรใหม่',
  'sub.cardHolder': 'ชื่อบนบัตร *',
  'sub.cardNumber': 'หมายเลขบัตร *',
  'sub.expiryDate': 'วันหมดอายุ *',
  'sub.addCard': 'เพิ่มบัตร',
  // Change Card Modal
  'sub.choosePayment': 'เลือกวิธีการชำระเงิน',
  'sub.active': 'ใช้งานอยู่',
  'sub.close': 'ปิด',
  // Toast messages
  'sub.toast.cancelled': 'การสมัครสมาชิกของคุณถูกยกเลิกเมื่อสิ้นสุดรอบการเรียกเก็บเงิน',
  'sub.toast.reactivated': 'เปิดใช้งานการสมัครสมาชิกของคุณอีกครั้งสำเร็จ!',
  'sub.toast.planChanged': 'เปลี่ยนแผนเป็น {{plan}} สำเร็จ!',
  'sub.toast.defaultChanged': 'เปลี่ยนวิธีการชำระเงินเริ่มต้นแล้ว',
  'sub.toast.cannotDeleteDefault': 'ไม่สามารถลบบัตรเริ่มต้นได้',
  'sub.toast.cardRemoved': 'ลบบัตรแล้ว',
  'sub.toast.fillAll': 'กรุณากรอกข้อมูลให้ครบทุกช่อง',
  'sub.toast.cardAdded': 'เพิ่มบัตรใหม่สำเร็จ!',
  'sub.toast.billingSaved': 'บันทึกที่อยู่สำหรับออกใบแจ้งหนี้แล้ว',
  'sub.toast.invoiceDownloaded': 'ดาวน์โหลดใบแจ้งหนี้ {{id}} แล้ว!',
  'sub.toast.pdfError': 'เกิดข้อผิดพลาดในการสร้าง PDF',
  // Chat interface
  'sub.notEnoughCredits': 'เครดิตไม่เพียงพอ',
  'sub.needCredits': 'คุณต้องการอย่างน้อย {{count}} เครดิตต่อคำถาม',
  'sub.creditsLow': 'เครดิตกำลังจะหมด',
  'sub.questionsLeft': 'สามารถถามได้ {{count}} คำถาม',
  'sub.plan': 'แผน',
  'sub.base': 'พื้นฐาน',
  'sub.unlimited': 'ไม่จำกัด',
  'sub.status.active': 'ใช้งานอยู่',
  'sub.status.cancelled': 'ยกเลิกแล้ว',
  'sub.status.paused': 'หยุดชั่วคราว',
  'sub.invoice': 'ใบแจ้งหนี้',
  'sub.from': 'จาก',
  'sub.to': 'ถึง',
  'sub.vatId': 'เลขประจำตัวผู้เสียภาษี',
  'sub.tel': 'โทร',
  'sub.invoiceDate': 'วันที่ใบแจ้งหนี้',
  'sub.invoiceNumber': 'เลขที่ใบแจ้งหนี้',
  'sub.paymentStatus': 'สถานะการชำระเงิน',
  'sub.creditCard': 'บัตรเครดิต',
  'sub.quantity': 'จำนวน',
  'sub.price': 'ราคา',
  'sub.amount': 'จำนวนเงิน',
  'sub.subtotal': 'รวมย่อย',
  'sub.bank': 'ธนาคาร',
  'sub.card': 'บัตร',
  'sub.cvc': 'CVC',
  'sub.cardHolderPlaceholder': 'John Doe',

  // ─── Admin Panel ─────────────────────────────────────────────────────────────
  'admin.title': 'แดชบอร์ดผู้ดูแลระบบ',
  'admin.subtitle': 'ศูนย์ควบคุม',
  'admin.superAdmin': 'ผู้ดูแลระบบสูงสุด',
  'admin.logout': 'ออกจากระบบ',
  'admin.tabs.users': 'การจัดการผู้ใช้',
  'admin.tabs.downgrades': 'ดาวน์เกรด',
  'admin.tabs.tips': 'เคล็ดลับประจำวัน',
  'admin.tabs.coupons': 'รหัสคูปอง',
  'admin.tabs.website': 'เครื่องมือแก้ไขเว็บไซต์',
  'admin.tabs.ai': 'การตั้งค่า AI',
  'admin.tabs.transactions': 'บันทึกธุรกรรม',
  'admin.tabs.stats': 'สถิติ',
  'admin.users.searchPlaceholder': 'ค้นหาผู้ใช้ (อีเมลหรือชื่อ)...',
  'admin.users.manageSubscription': 'จัดการการสมัครสมาชิก',
  'admin.users.grantFree': 'ให้บัญชีฟรี',
  'admin.users.blockUser': 'บล็อกผู้ใช้',
  'admin.users.cancellationPlaceholder': 'เหตุผลที่ยกเลิกการสมัครสมาชิก?',
  'admin.users.selectPlan': 'เลือกแผน',
  'admin.users.subChanged': 'เปลี่ยนการสมัครสมาชิกของ {{name}} เป็น {{plan}}',
  'admin.users.noReasonGiven': 'ไม่ระบุเหตุผล',
  'admin.users.subCancelled': 'ยกเลิกการสมัครสมาชิกของ {{name}} (ใช้ได้จนถึง {{date}})',
  'admin.users.paused': 'หยุดชั่วคราว',
  'admin.users.subPaused': 'หยุดการสมัครสมาชิกของ {{name}} ชั่วคราว',
  'admin.users.subReactivated': 'เปิดใช้งานการสมัครสมาชิกของ {{name}} อีกครั้ง',
  'admin.users.freeAccount': 'บัญชีฟรี',
  'admin.users.blocked': 'ถูกบล็อก',
  'admin.users.cancelledExpiring': 'ยกเลิก (กำลังจะหมดอายุ)',
  'admin.users.cancelledOn': 'ยกเลิกเมื่อ:',
  'admin.users.endsOn': 'สิ้นสุด:',
  'admin.users.daysRemaining': 'วัน remaining',
  'admin.users.expired': '(หมดอายุแล้ว)',
  'admin.users.total': 'ทั้งหมด:',
  'admin.users.usersLabel': 'ผู้ใช้',
  'admin.users.free': 'ฟรี',
  'admin.users.block': 'บล็อก',
  'admin.users.unblock': 'ปลดบล็อก',
  'admin.users.unblockUser': 'ปลดบล็อกผู้ใช้',
  'admin.users.selectAction': 'เลือกการดำเนินการ',
  'admin.users.cancelSub': 'ยกเลิกการสมัครสมาชิก',
  'admin.users.cancelSubDesc': 'ยกเลิกสิ้นเดือน',
  'admin.users.pauseSub': 'หยุดการสมัครสมาชิกชั่วคราว',
  'admin.users.pauseSubDesc': 'หยุดชั่วคราว',
  'admin.users.changePlan': 'เปลี่ยนแผน',
  'admin.users.changePlanDesc': 'สลับไปยังแผนอื่น',
  'admin.users.reactivateSub': 'เปิดใช้งานการสมัครสมาชิกอีกครั้ง',
  'admin.users.reactivateDesc': 'เลิกยกเลิก',
  'admin.users.alreadyCancelled': 'ยกเลิกการสมัครสมาชิกแล้ว',
  'admin.users.planLabel': 'แผน',
  'admin.users.cancellationReasonOpt': 'เหตุผลในการยกเลิก (ไม่บังคับ)',
  'admin.users.cancelInfo1': 'การสมัครสมาชิกจะสิ้นสุดในวันที่',
  'admin.users.cancelInfo2': '(สิ้นเดือน) จนถึงตอนนั้นผู้ใช้มีการเข้าถึงแบบเต็ม ไม่มีการคืนเงิน',
  'admin.users.newPlan': 'แผนใหม่',
  'admin.users.warning': 'คำเตือน',
  'admin.users.blockDesc': 'ผู้ใช้จะถูกออกจากระบบทันทีและไม่สามารถเข้าสู่ระบบอีกครั้ง เซสชันที่ใช้งานอยู่ทั้งหมดจะสิ้นสุดลง',
  'admin.users.confirmUnblock': 'ยืนยันการปลดบล็อก',
  'admin.users.unblockDesc': 'ผู้ใช้สามารถเข้าสู่ระบบอีกครั้งและใช้คุณสมบัติทั้งหมด',
  'admin.users.afterBlock': 'หลังจากบล็อก:',
  'admin.users.afterUnblock': 'หลังจากปลดบล็อก:',
  'admin.users.noAccountAccess': 'ไม่สามารถเข้าถึงบัญชี',
  'admin.users.noNewAnalyses': 'ไม่สามารถวิเคราะห์ใหม่ได้',
  'admin.users.creditsStored': 'เครดิตและประวัติยังคงถูกเก็บไว้',
  'admin.users.accessRestored': 'การเข้าถึงบัญชีได้รับการคืนค่า',
  'admin.users.allFeaturesAvail': 'คุณสมบัติทั้งหมดพร้อมใช้งานอีกครั้ง',
  'admin.users.creditsPreserved': 'เครดิตและประวัติถูกเก็บรักษาไว้',
  'admin.users.downgrade': 'ดาวน์เกรดแผน',
  'admin.users.grantFreeBtn': 'ให้ฟรี',
  'admin.users.durationMonths': 'ระยะเวลา (เดือน)',
  'admin.users.months': 'เดือน',
  'admin.users.freePlan': 'ฟรี',
  'admin.users.freeSummary': 'ได้รับ',
  'admin.users.withCredits': 'ด้วย',
  'admin.users.credits': 'เครดิต',
  'admin.users.subInfo': 'ข้อมูลการสมัครสมาชิก',
  'admin.users.currentPlan': 'แผนปัจจุบัน',
  'admin.users.joined': 'เข้าร่วม',
  'admin.users.totalSpent': 'ใช้จ่ายทั้งหมด',
  'admin.users.paymentMethod': 'วิธีการชำระเงิน',
  'admin.users.validThrough': 'ใช้ได้จนถึง',
  'admin.users.billingAddress': 'ที่อยู่สำหรับออกใบแจ้งหนี้',
  'admin.users.transactionHistory': 'ประวัติธุรกรรม',
  'admin.users.cancellationDate': 'วันที่ยกเลิก',
  'admin.users.validUntil': 'ใช้ได้จนถึง (สิ้นเดือน)',
  'admin.users.cancellationReason': 'เหตุผลในการยกเลิก',
  'admin.users.noReason': 'ไม่ระบุเหตุผล',
  'admin.users.timeRemaining': 'เวลาที่เหลือ',
  'admin.users.daysUntilDeactivation': 'วันจนกว่าจะปิดใช้งาน',
  'admin.table.user': 'ผู้ใช้',
  'admin.table.plan': 'แผน',
  'admin.table.subStatus': 'สถานะการสมัครสมาชิก',
  'admin.table.cancellation': 'การยกเลิก',
  'admin.table.payment': 'วิธีการชำระเงิน',
  'admin.table.spending': 'การใช้จ่าย',
  'admin.table.actions': 'การดำเนินการ',
  'admin.actions.viewDetails': 'ดูรายละเอียด',
  'admin.actions.manageSubscription': 'จัดการการสมัครสมาชิก',
  'admin.actions.grantFree': 'ให้การเข้าถึงฟรี',
  'admin.actions.block': 'บล็อกผู้ใช้',
  'admin.actions.unblock': 'ปลดบล็อกผู้ใช้',
  'admin.actions.cancel': 'ยกเลิก',
  'admin.actions.save': 'บันทึก',
  'admin.actions.delete': 'ลบ',
  'admin.actions.confirm': 'ยืนยัน',
  'admin.actions.done': 'เสร็จสิ้น',
  'admin.actions.edit': 'แก้ไข',
  'admin.actions.close': 'ปิด',
  'admin.table.status': 'สถานะ',
  'admin.filter.all': 'ทั้งหมด',
  'admin.subscription.active': 'ใช้งานอยู่',
  'admin.subscription.cancelled': 'ยกเลิกแล้ว',
  'admin.subscription.paused': 'หยุดชั่วคราว',
  'admin.subscription.unknown': 'ไม่ทราบ',
  'admin.status.active': 'ใช้งานอยู่',
  'admin.status.inactive': 'ไม่ใช้งาน',
  'admin.status.pending': 'รอดำเนินการ',
  'admin.status.approved': 'อนุมัติแล้ว',
  'admin.status.rejected': 'ปฏิเสธแล้ว',
  'admin.coupons.title': 'การจัดการคูปอง',
  'admin.coupons.subtitle': 'สร้างและจัดการรหัสคูปอง',
  'admin.coupons.newCoupon': 'คูปองใหม่',
  'admin.coupons.registrationCoupons': 'คูปองการลงทะเบียน',
  'admin.coupons.trialCoupons': 'คูปองการเข้าถึงทดลองใช้',
  'admin.coupons.type': 'ประเภท',
  'admin.coupons.plan': 'แผน',
  'admin.coupons.value': 'มูลค่า',
  'admin.coupons.usage': 'การใช้งาน',
  'admin.coupons.validUntil': 'ใช้ได้จนถึง',
  'admin.coupons.created': 'สร้างเมื่อ',
  'admin.coupons.actions': 'การดำเนินการ',
  'admin.coupons.copyCode': 'คัดลอกรหัส',
  'admin.coupons.allPlans': 'ทุกแผน',
  'admin.coupons.discount': 'ส่วนลด',
  'admin.coupons.days': 'วัน',
  'admin.coupons.months': 'เดือน',
  'admin.coupons.free': 'ฟรี',
  'admin.coupons.unlimited': 'ไม่จำกัด',
  'admin.coupons.createRegistration': 'สร้างคูปองการลงทะเบียน',
  'admin.coupons.createTrial': 'สร้างคูปองการเข้าถึงทดลองใช้',
  'admin.coupons.couponCode': 'รหัสคูปอง',
  'admin.coupons.codePlaceholder': 'z.B. NF-7X3K9M',
  'admin.coupons.generateCode': 'สร้างรหัสใหม่',
  'admin.coupons.alertFillRequired': 'กรุณากรอกข้อมูลในช่องที่จำเป็นทั้งหมด',
  'admin.coupons.alertSelectExpiry': 'กรุณาเลือกวันหมดอายุหรือเปิดใช้งาน "อายุไม่จำกัด"',
  'admin.coupons.alertCreateError': 'เกิดข้อผิดพลาดในการสร้างคูปอง',
  'admin.coupons.confirmDelete': 'คุณแน่ใจหรือไม่ที่จะลบคูปองนี้?',
  'admin.coupons.discountPercent': 'ส่วนลด (%)',
  'admin.coupons.bonusCredits': 'เครดิตโบนัส',
  'admin.coupons.freeDuration': 'ระยะเวลาฟรี',
  'admin.coupons.maxUses': 'การใช้งานสูงสุด',
  'admin.coupons.expiryDate': 'วันหมดอายุ',
  'admin.coupons.unlimitedValidity': 'อายุไม่จำกัด',
  'admin.coupons.unlimitedUses': 'การใช้งานไม่จำกัด',
  'admin.coupons.trialCredits': 'เครดิตทดลองใช้',
  'admin.coupons.trialDuration': 'ระยะเวลาทดลองใช้',
  'admin.coupons.typePlaceholder': 'z.B. Early Bird, Partner, Influencer',
  'admin.coupons.duration': 'ระยะเวลา',
  'admin.stats.totalUsers': 'ผู้ใช้ทั้งหมด',
  'admin.stats.monthlyRevenue': 'รายได้รายเดือน',
  'admin.stats.activeSubscriptions': 'การสมัครสมาชิกที่ใช้งานอยู่',
  'admin.stats.average': 'เฉลี่ย',
  'admin.stats.revenuePerUser': 'รายได้ต่อผู้ใช้',
  'admin.stats.grossRevenue': 'รายได้รวม',
  'admin.stats.net': 'สุทธิ',
  'admin.stats.netRevenue': 'รายได้สุทธิ',
  'admin.stats.churnRate': 'อัตราการเลิกใช้',
  'admin.stats.planDistribution': 'การกระจายแผน',
  'admin.stats.users': 'ผู้ใช้',
  'admin.stats.revenueByPlan': 'รายได้ตามแผน',
  'admin.stats.recentActivity': 'กิจกรรมล่าสุด',
  'admin.stats.activity1': 'Thomas Weber อัปเกรดเป็น Builder',
  'admin.stats.activity2': 'ผู้ใช้ใหม่ลงทะเบียน',
  'admin.stats.activity3': 'Anna Schmidt อัปเกรดเป็น Pro',
  'admin.stats.hoursAgo2': '2 ชั่วโมงที่แล้ว',
  'admin.stats.hoursAgo5': '5 ชั่วโมงที่แล้ว',
  'admin.stats.dayAgo1': '1 วันที่แล้ว',
  'admin.stats.couponStats': 'สถิติคูปอง',
  'admin.stats.totalRedemptions': 'การใช้งานทั้งหมด',
  'admin.stats.activeCoupons': 'คูปองที่ใช้งานอยู่',
  'admin.stats.registrationRedemptions': 'การใช้งานคูปองลงทะเบียน',
  'admin.stats.trialRedemptions': 'การใช้งานคูปองทดลองใช้',
  'admin.stats.couponDistribution': 'การกระจายคูปอง',
  'admin.stats.registrationCoupons': 'คูปองลงทะเบียน',
  'admin.stats.trialCoupons': 'คูปองทดลองใช้',
  'admin.stats.expiredInactive': 'หมดอายุ/ไม่ใช้งาน',
  'admin.stats.topCoupons': 'คูปองยอดนิยมตามการใช้งาน',
  'admin.stats.redemptions': 'การใช้งาน',
  'admin.stats.noCouponsRedeemed': 'ยังไม่มีการใช้คูปอง',
  'admin.downgrade.pending': 'รอดำเนินการ',
  'admin.downgrade.refunds': 'การคืนเงิน',
  'admin.downgrade.sectionRequests': 'คำขอ',
  'admin.downgrade.sectionStats': 'สถิติ',
  'admin.downgrade.sectionRules': 'กฎ',
  'admin.downgrade.pendingRequests': 'คำขอที่รอดำเนินการ',
  'admin.downgrade.approvedRequests': 'คำขอที่อนุมัติ',
  'admin.downgrade.rejectedRequests': 'คำขอที่ปฏิเสธ',
  'admin.downgrade.activeRules': 'กฎที่ใช้งานอยู่',
  'admin.downgrade.autoRules': 'กฎการดาวน์เกรดอัตโนมัติ',
  'admin.downgrade.autoRulesDesc': 'สร้างกฎที่ทริกเกอร์การดาวน์เกรดโดยอัตโนมัติตามพฤติกรรมการใช้งาน',
  'admin.downgrade.newRule': 'กฎใหม่',
  'admin.downgrade.totalRules': 'กฎทั้งหมด',
  'admin.downgrade.triggeredActions': 'การดำเนินการที่ถูกทริกเกอร์',
  'admin.downgrade.conditionsAnd': 'เงื่อนไข (เชื่อมด้วย AND)',
  'admin.downgrade.action': 'การดำเนินการ',
  'admin.downgrade.successTitle': 'ดาวน์เกรดสำเร็จ!',
  'admin.downgrade.successDesc': 'ผู้ใช้ถูกดาวน์เกรดเรียบร้อยและดำเนินการคืนเงินแล้ว',
  'admin.downgrade.closing': 'กำลังปิด...',
  'admin.downgrade.title': 'ดาวน์เกรดผู้ใช้',
  'admin.downgrade.currentPlan': 'แผนปัจจุบัน',
  'admin.downgrade.spending': 'การใช้จ่าย',
  'admin.downgrade.availablePlans': 'แผนที่พร้อมสำหรับการดาวน์เกรด',
  'admin.downgrade.perMonth': 'ต่อเดือน',
  'admin.downgrade.refundCalc': 'การคำนวณการคืนเงิน',
  'admin.downgrade.currentPlanLabel': 'แผนปัจจุบัน',
  'admin.downgrade.newPlan': 'แผนใหม่',
  'admin.downgrade.remainingDays': 'วันที่เหลือ',
  'admin.downgrade.daysOf': '15 จาก 30 วัน',
  'admin.downgrade.proRataRefund': 'การคืนเงินตามสัดส่วน',
  'admin.downgrade.importantNote': 'หมายเหตุสำคัญ',
  'admin.downgrade.warningDesc': 'การดาวน์เกรดจะดำเนินการทันที ผู้ใช้จะสูญเสียการเข้าถึงคุณสมบัติพรีเมียมและเครดิตที่เกินจะถูกลบ',
  'admin.downgrade.processing': 'กำลังดำเนินการ...',
  'admin.downgrade.execute': 'ดำเนินการดาวน์เกรด',
  'admin.downgrade.notification': 'การแจ้งเตือน',
  'admin.downgrade.noNotification': 'ไม่มีการแจ้งเตือน',
  'admin.downgrade.daysPeriod': 'วัน grace period',
  'admin.downgrade.created': 'สร้างเมื่อ:',
  'admin.downgrade.triggered': 'ถูกทริกเกอร์',
  'admin.downgrade.noRules': 'ยังไม่ได้สร้างกฎ',
  'admin.downgrade.createFirstRule': 'สร้างกฎแรก',
  'admin.downgrade.editRule': 'แก้ไขกฎ',
  'admin.downgrade.createRule': 'สร้างกฎใหม่',
  'admin.downgrade.ruleName': 'ชื่อกฎ',
  'admin.downgrade.description': 'คำอธิบาย',
  'admin.downgrade.allConditions': 'เงื่อนไข (ต้องเป็นไปตามทั้งหมด)',
  'admin.downgrade.addCondition': 'เพิ่มเงื่อนไข',
  'admin.downgrade.type': 'ประเภท',
  'admin.downgrade.value': 'ค่า',
  'admin.downgrade.fromPlan': 'จากแผน',
  'admin.downgrade.toPlan': 'ไปยังแผน',
  'admin.condition.inactivity': 'ไม่มีการเคลื่อนไหว',
  'admin.condition.creditUsage': 'การใช้งานเครดิต',
  'admin.condition.loginFrequency': 'ความถี่ในการเข้าสู่ระบบ',
  'admin.condition.featureUsage': 'การใช้งานคุณสมบัติ',
  'admin.condition.supportTickets': 'ตั๋วสนับสนุน',
  'admin.operator.lessThan': 'น้อยกว่า',
  'admin.operator.greaterThan': 'มากกว่า',
  'admin.operator.equals': 'เท่ากับ',
  'admin.operator.between': 'ระหว่าง',
  'admin.unit.days': 'วัน',
  'admin.unit.perMonth': 'ต่อเดือน',
  'admin.unit.count': 'จำนวน',
  'admin.transactions.all': 'ธุรกรรมทั้งหมด',
  'admin.transactions.allCards': 'บัตรทั้งหมด',
  'admin.transactions.notFound': 'ไม่พบธุรกรรม',
  'admin.transactions.totalLabel': 'รวม',
  'admin.transactions.transactions': 'ธุรกรรม',
  'admin.tips.title': 'เคล็ดลับประจำวัน',
  'admin.tips.subtitle': 'สร้างและจัดการเคล็ดลับที่แสดงแก่ผู้ใช้ทั้งหมด',
  'admin.tips.active': 'ใช้งานอยู่',
  'admin.tips.currentlyShown': 'เคล็ดลับนี้กำลังแสดงแก่ผู้ใช้ทั้งหมด',
  'admin.tips.createNew': 'สร้างเคล็ดลับใหม่',
  'admin.tips.generating': 'กำลังสร้าง...',
  'admin.tips.generateAI': 'สร้างเคล็ดลับด้วย AI',
  'admin.tips.titleLabel': 'ชื่อเรื่อง',
  'admin.tips.titlePlaceholder': 'z.B. Tip of the Day',
  'admin.tips.category': 'หมวดหมู่',
  'admin.tips.categoryTip': 'เคล็ดลับ',
  'admin.tips.categoryFeature': 'คุณสมบัติใหม่',
  'admin.tips.categoryProductivity': 'ประสิทธิภาพการทำงาน',
  'admin.tips.categoryUpdate': 'อัปเดต',
  'admin.tips.content': 'เนื้อหา',
  'admin.tips.contentPlaceholder': 'เขียนเคล็ดลับของคุณสำหรับผู้ใช้ที่นี่...',
  'admin.tips.addTip': 'เพิ่มเคล็ดลับ',
  'admin.tips.allTips': 'เคล็ดลับทั้งหมด',
  'admin.tips.noTips': 'ยังไม่ได้สร้างเคล็ดลับ',
  'admin.tips.noTipsHint': 'คลิก "สร้างเคล็ดลับด้วย AI" เพื่อเริ่มต้น',
  'admin.noData': 'ไม่มีข้อมูล',
  'admin.range.7d': '7 วัน',
  'admin.range.30d': '30 วัน',
  'admin.range.90d': '90 วัน',
  'admin.range.1y': '1 ปี',
  'admin.actions.saveSettings': 'บันทึกการตั้งค่า',
  'admin.actions.create': 'สร้าง',
  'admin.downgrade.sectionReports': 'รายงาน',
  'admin.downgrade.settings': 'การตั้งค่าการดาวน์เกรด',
  'admin.downgrade.autoApprove': 'การอนุมัติอัตโนมัติ',
  'admin.downgrade.autoApproveDesc': 'อนุมัติคำขอดาวน์เกรดโดยอัตโนมัติ',
  'admin.downgrade.refundPolicy': 'นโยบายการคืนเงิน',
  'admin.downgrade.prorata': 'การคืนเงินตามสัดส่วน',
  'admin.downgrade.prorataDesc': 'คืนเงินตามสัดส่วนของวันที่เหลือ',
  'admin.downgrade.fullRefund': 'คืนเงินเต็มจำนวน',
  'admin.downgrade.fullRefundDesc': 'คืนเงินส่วนต่างราคาทั้งหมด',
  'admin.downgrade.noRefund': 'ไม่มีการคืนเงิน',
  'admin.downgrade.noRefundDesc': 'ดาวน์เกรดโดยไม่มีการคืนเงิน',
  'admin.downgrade.daysRemaining15': '(เหลือ 15 วัน)',
  'admin.downgrade.requestsTitle': 'คำขอดาวน์เกรด',
  'admin.downgrade.approvalRate': 'อัตราการอนุมัติ',
  'admin.downgrade.mostCommonTransition': 'การเปลี่ยนแปลงที่พบบ่อยที่สุด',
  'admin.downgrade.mostCommonReason': 'เหตุผลที่พบบ่อยที่สุด',
  'admin.downgrade.avgProcessingTime': 'เวลาในการประมวลผลเฉลี่ย',
  'admin.downgrade.avgTimeDesc': 'เวลาเฉลี่ยในการตัดสินใจ',
  'admin.downgrade.totalRefunds': 'การคืนเงินทั้งหมด',
  'admin.downgrade.pendingRefunds': 'การคืนเงินที่รอดำเนินการ',
  'admin.downgrade.summary': 'สรุป',
  'admin.downgrade.total': 'รวม',
  'admin.downgrade.csvDesc': 'สำหรับ Excel, Google Sheets',
  'admin.downgrade.downloadCSV': 'ดาวน์โหลดเป็น CSV',
  'admin.downgrade.jsonDesc': 'สำหรับนักพัฒนา, APIs',
  'admin.downgrade.downloadJSON': 'ดาวน์โหลดเป็น JSON',
  'admin.downgrade.exportInfo': 'การส่งออกประกอบด้วย',
  'admin.downgrade.entries': 'รายการจากช่วงเวลาที่เลือก',
  'admin.downgrade.topReasons': 'เหตุผลการดาวน์เกรดที่พบบ่อยที่สุด',
  'admin.downgrade.refundHistory': 'ประวัติการคืนเงิน',
  'admin.downgrade.noRefunds': 'ยังไม่มีการคืนเงิน',
  'admin.downgrade.statistics': 'สถิติการดาวน์เกรด',
  'admin.downgrade.requests': 'คำขอ',
  'admin.downgrade.monthlyTrend': 'แนวโน้มรายเดือน',
  'admin.downgrade.planTransitions': 'การเปลี่ยนแปลงแผน',
  'admin.downgrade.trend': 'แนวโน้ม (เทียบกับเดือนก่อน)',
  'admin.downgrade.trendDesc': 'การดาวน์เกรดน้อยลง = ดีขึ้น',
  'admin.coupons.allPlansUniversal': 'ทุกแผน (สากล)',
  'admin.coupons.onlyStarter': 'Starter เท่านั้น',
  'admin.coupons.onlyPro': 'Pro เท่านั้น',
  'admin.coupons.onlyBuilder': 'Builder เท่านั้น',
  'admin.coupons.allPlansHint': 'เลือก "ทุกแผน" สำหรับคูปองสากล',
  'admin.coupons.discountOptional': 'ส่วนลด % (ไม่บังคับ)',
  'admin.coupons.discountPlaceholder': 'z.B. 50 สำหรับส่วนลด 50%',
  'admin.coupons.bonusCreditsOptional': 'เครดิตโบนัส (ไม่บังคับ)',
  'admin.coupons.bonusCreditsPlaceholder': 'z.B. 500',
  'admin.coupons.freeDurationOptional': 'ระยะเวลาฟรี (ไม่บังคับ)',
  'admin.coupons.durationPlaceholder': 'z.B. 30',
  'admin.coupons.freeDurationHint': 'z.B. 30 วันใช้งานฟรี',
  'admin.coupons.noLimit': 'ไม่มีข้อจำกัดการใช้งาน',
  'admin.coupons.noExpiry': 'ไม่มีวันหมดอายุ',
  'admin.coupons.creditsPlaceholder': 'z.B. 100',
  'admin.coupons.creditsHint': 'จำนวนเครดิตสำหรับการเข้าถึงทดลองใช้',
  'admin.coupons.trialDurationHint': 'ระยะเวลาที่การเข้าถึงทดลองใช้ใช้งานได้',
  'admin.coupons.autoCalculated': 'คำนวณโดยอัตโนมัติจากระยะเวลาทดลองใช้',
  'admin.websiteEditor.title': 'เครื่องมือแก้ไขเว็บไซต์',
  'admin.websiteEditor.subtitle': 'แก้ไขทุกส่วนของหน้าแรก',
  'admin.websiteEditor.openPreview': 'เปิดตัวอย่าง',
  'admin.websiteEditor.group.structure': 'โครงสร้างหน้า',
  'admin.websiteEditor.group.design': 'การออกแบบและเค้าโครง',
  'admin.websiteEditor.group.settings': 'การตั้งค่า',
  'admin.websiteEditor.tab.navbar': 'เมนูนำทาง',
  'admin.websiteEditor.tab.howitworks': 'วิธีการทำงาน',
  'admin.websiteEditor.tab.about': 'เกี่ยวกับเรา',
  'admin.websiteEditor.tab.pricing': 'ราคา',
  'admin.websiteEditor.tab.sections': 'ส่วนต่างๆ',
  'admin.websiteEditor.tab.media': 'สื่อ',
  'admin.websiteEditor.tab.chatwidget': 'พูดคุยกับเรา',
  'admin.websiteEditor.tab.invoice': 'ใบแจ้งหนี้',
  'admin.websiteEditor.tab.legal': 'กฎหมาย',
  'admin.websiteEditor.tab.seo': 'SEO พื้นฐาน',
  'admin.websiteEditor.tab.advancedseo': 'SEO ขั้นสูง',
  'admin.websiteEditor.tab.versions': 'เวอร์ชัน',
  'admin.hero.title': 'แก้ไขส่วน Hero',
  'admin.hero.subtitle': 'ข้อความ ปุ่มและสถิติของหน้าแรก',
  'admin.hero.reset': 'รีเซ็ต',
  'admin.hero.save': 'บันทึก',
  'admin.hero.savedMsg': 'บันทึกข้อมูล Hero แล้ว!',
  'admin.hero.badge': 'ข้อความตรา',
  'admin.hero.headings': 'หัวเรื่อง',
  'admin.hero.line1White': 'บรรทัดที่ 1 (สีขาว)',
  'admin.hero.line2Gold': 'บรรทัดที่ 2 (สีทอง)',
  'admin.hero.subtitleSection': 'หัวเรื่องรอง',
  'admin.hero.line1': 'บรรทัดที่ 1',
  'admin.hero.line2': 'บรรทัดที่ 2',
  'admin.hero.buttons': 'ปุ่ม',
  'admin.hero.primaryBtn': 'ปุ่มหลัก (สีทอง)',
  'admin.hero.secondaryBtn': 'ปุ่มรอง (เส้นขอบ)',
  'admin.hero.stats': 'สถิติ',
  'admin.hero.statN': 'สถิติ {{n}}',
  'admin.hero.value': 'ค่า',
  'admin.hero.label': 'ป้ายกำกับ',
  'admin.hero.previewNote': 'การเปลี่ยนแปลงจะปรากฏบนหน้าแรกหลังจากบันทึก โหลดหน้าเว็บใหม่เพื่อดูตัวอย่าง',

  // Idea History
  'history.title': 'ประวัติไอเดีย',
  'history.countLabel': '{{count}} การวิเคราะห์',
  'history.recentLabel': 'การวิเคราะห์ล่าสุดของคุณ',
  'history.exportAll': 'ส่งออกทั้งหมด',
  'history.metrics.marketSize': 'ขนาดตลาด',
  'history.metrics.competition': 'การแข่งขัน',
  'history.metrics.startingCapital': 'เงินทุนเริ่มต้น',
  'history.metrics.timeToMarket': 'เวลาในการเข้าสู่ตลาด',
  'history.metrics.profitPotential': 'ศักยภาพกำไร',
  'history.metrics.scalability': 'ความสามารถในการขยายขนาด',
  'history.summary.title': 'สรุป',
  'history.download': 'ดาวน์โหลด',
  'history.downloadJSON': 'บันทึกเป็น JSON',
  'history.downloadTXT': 'บันทึกเป็น TXT',
  'history.downloadPDF': 'บันทึกเป็น PDF',
  'history.fullAnalysis': 'การวิเคราะห์แบบเต็ม',
  'history.searchPlaceholder': 'ค้นหาตามชื่อเรื่องหรือแท็ก...',
  'history.filterAll': 'การให้คะแนนทั้งหมด',
  'history.loading': 'กำลังโหลดการวิเคราะห์...',
  'history.noResults': 'ไม่พบผลลัพธ์',
  'history.empty': 'ยังไม่มีการวิเคราะห์',
  'history.emptyHint': 'เริ่มการวิเคราะห์ในผู้ช่วย AI',
  'history.delete': 'ลบ',
  'history.cancel': 'ยกเลิก',
  'history.deleteModalTitle': 'ลบการวิเคราะห์?',
  'history.deleteModalDesc': '"{{title}}" จะถูกลบอย่างถาวร',
  'history.errorLoading': 'เกิดข้อผิดพลาดในการโหลดการวิเคราะห์',
  'history.deleteSuccess': 'ลบการวิเคราะห์สำเร็จ',
  'history.deleteError': 'เกิดข้อผิดพลาดในการลบการวิเคราะห์',
  'history.jsonExported': 'ส่งออก JSON แล้ว',
  'history.txtExported': 'ส่งออก TXT แล้ว',
  'history.allExported': 'ส่งออก {{count}} ไอเดียแล้ว',
  'history.analysisHeader': 'การวิเคราะห์ไอเดีย',
  'history.titleLabel': 'ชื่อเรื่อง',
  'history.ratingLabel': 'การให้คะแนน',
  'history.dateLabel': 'วันที่',
  'history.creditsLabel': 'เครดิต',
  'history.analysisSection': 'การวิเคราะห์',

  // Overview
  'overview.title': 'ภาพรวม',
  'overview.last24h': '24 ชั่วโมงที่ผ่านมา',
  'overview.analysesToday': 'การวิเคราะห์วันนี้',
  'overview.totalAnalyses': 'การวิเคราะห์ทั้งหมด',
  'overview.successRate': 'อัตราความสำเร็จ',
  'overview.topRatings': 'การให้คะแนนสูงสุด',
  'overview.recentActivity': 'กิจกรรมล่าสุด',
  'overview.viewAll': 'ดูทั้งหมด',
  'overview.quickAccess': 'การเข้าถึงด่วน',
  'overview.quick.newAnalysis': 'เริ่มการวิเคราะห์ใหม่',
  'overview.quick.newAnalysisDesc': 'เริ่มการวิเคราะห์ช่องทางด้วย AI ใหม่',
  'overview.quick.myAnalyses': 'การวิเคราะห์ของฉัน',
  'overview.quick.myAnalysesDesc': 'ดูการวิเคราะห์ก่อนหน้าทั้งหมด',
  'overview.quick.buyCredits': 'ซื้อเครดิต',
  'overview.quick.buyCreditsDesc': 'เครดิตเพิ่มเติมสำหรับการวิเคราะห์มากขึ้น',
  'overview.quick.settings': 'การตั้งค่า',
  'overview.quick.settingsDesc': 'ปรับแต่งโปรไฟล์และการตั้งค่า',
  'overview.unlimitedCredits': 'มีเครดิตไม่จำกัด',
  'overview.creditsAvailable': 'เครดิตที่มี',
  'overview.upgradePlan': 'อัปเกรดแผน',
  'overview.buyCredits': 'ซื้อเครดิต',
  'overview.creditUsage': 'การใช้เครดิตเดือนนี้',
  'overview.available': 'ที่มี',

  // --- Admin New Keys ---
  'admin.transactions.upgrades': 'การอัปเกรด',
  'admin.transactions.downgrades': 'การดาวน์เกรด',
  'admin.transactions.visa': 'Visa',
  'admin.transactions.mastercard': 'Mastercard',
  'admin.transactions.amex': 'Amex',

  'admin.users.grantFreeSuccess': '{{name}} มี {{months}} เดือนของแผน {{plan}} ฟรี',
  'admin.users.blockSuccess': 'บล็อก {{name}} แล้ว',
  'admin.users.unblockSuccess': 'ปลดบล็อก {{name}} แล้ว',
  'admin.users.removeFreeSuccess': 'ลบสถานะฟรีของ {{name}} แล้ว',

  'admin.downgrade.plans.builder': 'Builder',
  'admin.downgrade.plans.pro': 'Pro',
  'admin.downgrade.plans.starter': 'Starter',
  'admin.downgrade.plans.free': 'ฟรี',

  'admin.unit.percent': '%',

  'admin.tips.discoverNewFeature': 'ค้นพบคุณสมบัติใหม่',
  'admin.tips.productivityBoost': 'เพิ่มประสิทธิภาพการทำงาน',
  'admin.tips.importantUpdate': 'อัปเดตสำคัญ',
  'admin.tips.tipOfDay': 'เคล็ดลับประจำวัน',

  'admin.actions.activate': 'เปิดใช้งาน',
  'admin.actions.deactivate': 'ปิดใช้งาน',
  'admin.websiteEditor.tab.features': 'คุณสมบัติ',
  'admin.websiteEditor.tab.testimonials': 'คำรับรอง',
  'admin.websiteEditor.tab.faq': 'คำถามที่พบบ่อย',
  'admin.websiteEditor.tab.cta': 'CTA',
  'admin.websiteEditor.tab.footer': 'ส่วนท้าย',
  'admin.websiteEditor.tab.design': 'การออกแบบ',
  'admin.websiteEditor.tab.customcode': 'โค้ดที่กำหนดเอง',
  'admin.websiteEditor.tab.socials': 'โซเชียลมีเดีย',
  'admin.websiteEditor.tab.importexport': 'นำเข้า/ส่งออก',

  // --- AI Settings Editor ---
  'admin.ai.title': 'การตั้งค่าผู้ช่วย AI',
  'admin.ai.subtitle': 'กำหนดค่าพฤติกรรม รูปแบบและความลึกของการวิเคราะห์',
  'admin.ai.smartWeightingActive': 'การให้น้ำหนักอัจฉริยะทำงานอยู่',
  'admin.ai.smartWeightingDesc': 'AI รวมมุมมองทั้งหมดโดยอัตโนมัติด้วยการให้น้ำหนักอัจฉริยะ เมื่อมี presets หลายตัว ตัวแรกจะได้รับน้ำหนักสูงกว่า (preset หลัก) คุณยังสามารถปรับการให้น้ำหนักด้วยตนเองได้',
  'admin.ai.modelTitle': 'โมเดล AI IdeaVerdict',
  'admin.ai.modelSubtitle': 'เลือกเครื่องมือ AI สำหรับการวิเคราะห์ผู้ใช้ทั้งหมด',
  'admin.ai.activeModel': 'โมเดลที่ใช้งานอยู่:',
  'admin.ai.activeModelDesc': 'ผู้ใช้ทุกคนได้รับการตอบสนองจากโมเดลนี้',
  'admin.ai.recommendations': 'คำแนะนำสำหรับผลลัพธ์ที่ดีที่สุด',
  'admin.ai.new': 'ใหม่',
  'admin.ai.recommendationsDesc': 'การรวม preset ที่ผ่านการทดสอบแล้วซึ่งให้คุณภาพการวิเคราะห์ที่ดีที่สุด',
  'admin.ai.recommendationsInfo': 'การรวมกันเหล่านี้ได้รับการทดสอบและให้ผลลัพธ์ที่ดีที่สุด คลิกคำแนะนำเพื่อนำไปใช้ทันที',
  'admin.ai.active': 'ใช้งานอยู่',
  'admin.ai.apply': 'นำไปใช้',
  'admin.ai.avoid': 'หลีกเลี่ยง',
  'admin.ai.excellentQuality': 'คุณภาพดีเยี่ยม',
  'admin.ai.goodQuality': 'คุณภาพดี',
  'admin.ai.poorQuality': 'คุณภาพเจือจาง - ไม่แนะนำ',
  'admin.ai.proTips': 'เคล็ดลับมือโปร',
  'admin.ai.tip1Title': '2 presets เหมาะสมที่สุด:',
  'admin.ai.tip1Desc': 'มุมมองที่ชัดเจนโดยไม่เจือจาง',
  'admin.ai.tip2Title': 'preset หลักมีความสำคัญ:',
  'admin.ai.tip2Desc': 'preset แรกมีอิทธิพลมากที่สุด',
  'admin.ai.tip3Title': 'หลีกเลี่ยงสิ่งที่ตรงกันข้าม:',
  'admin.ai.tip3Desc': '"EXTREME" + "Creative" = ขัดแย้งกัน',
  'admin.ai.tip4Title': 'สูงสุด 3 presets:',
  'admin.ai.tip4Desc': 'ด้วย 4+ presets ผลลัพธ์จะทั่วไปเกินไป',
  'admin.ai.warningManyPresets': 'คำเตือน: หลาย Presets',
  'admin.ai.warningManyPresetsDesc': 'คุณเลือก {{count}} presets ซึ่งอาจทำให้ผลลัพธ์เจือจาง',
  'admin.ai.warningRecommend': 'แนะนำ: สูงสุด 2-3 presets',
  'admin.ai.forOptimalResults': 'เพื่อผลลัพธ์ที่ดีที่สุด',
  'admin.ai.presets': 'Presets',
  'admin.ai.multiSelect': '(เลือกได้หลายตัว)',
  'admin.ai.presetsDesc': 'เลือกหนึ่งหรือหลาย presets preset แรกคือ preset หลักที่มีน้ำหนักสูงสุด',
  'admin.ai.primaryPreset': 'Preset หลัก',
  'admin.ai.weightControl': 'การควบคุมน้ำหนัก',
  'admin.ai.weightControlDesc': 'ปรับว่าแต่ละ preset มีอิทธิพลต่อการวิเคราะห์มากน้อยเพียงใด',
  'admin.ai.manual': 'ด้วยตนเอง',
  'admin.ai.automatic': 'อัตโนมัติ',
  'admin.ai.autoWeightingActive': 'การให้น้ำหนักอัตโนมัติทำงานอยู่:',
  'admin.ai.autoWeightingDesc': 'น้ำหนักถูกปรับให้เหมาะสมโดยอัตโนมัติตามจำนวน presets',
  'admin.ai.primary': 'หลัก',
  'admin.ai.totalWeight': 'รวม',
  'admin.ai.shouldBe100': 'ควรเป็น 100%',
  'admin.ai.normalize': 'ทำให้เป็นมาตรฐาน',
  'admin.ai.combinedSettings': 'การตั้งค่ารวม',
  'admin.ai.presetsCount': 'presets',
  'admin.ai.strictness': 'ความเข้มงวด',
  'admin.ai.realism': 'ความสมจริง',
  'admin.ai.creativity': 'ความคิดสร้างสรรค์',
  'admin.ai.detailLevel': 'ระดับรายละเอียด',
  'admin.ai.customInstructions': 'คำแนะนำที่กำหนดเอง',
  'admin.ai.customInstructionsDesc': 'คำแนะนำเพิ่มเติมที่รวมกับ presets',
  'admin.ai.customInstructionsPlaceholder': 'z.B. "เน้นที่ตลาด DACH", "ใช้ตัวเลขที่เป็นรูปธรรมเสมอ", "เปรียบเทียบกับคู่แข่งที่มีอยู่", "ตอบพร้อมตัวอย่างเสมอ"...',
  'admin.ai.customInstructionsHint': 'คำแนะนำเหล่านี้จะรวมกับ presets ที่เลือกโดยอัตโนมัติ',
  'admin.ai.manualFinetuning': 'การปรับแต่งด้วยตนเอง',
  'admin.ai.manualFinetuningHint': '(ไม่บังคับ, แทนที่ค่า preset)',
  'admin.ai.manualFinetuningDesc': 'ปรับค่าที่รวมด้วยตนเองหากคุณต้องการปรับแต่งบางอย่าง',
  'admin.ai.tone': 'น้ำเสียง',
  'admin.ai.mild': 'อ่อน',
  'admin.ai.strict': 'เข้มงวด',
  'admin.ai.creative': 'สร้างสรรค์',
  'admin.ai.realistic': 'สมจริง',
  'admin.ai.conservative': 'อนุรักษ์นิยม',
  'admin.ai.compact': 'กะทัดรัด',
  'admin.ai.detailed': 'ละเอียด',
  'admin.ai.responseLength': 'ความยาวการตอบสนอง',
  'admin.ai.short': 'สั้นและกระชับ',
  'admin.ai.medium': 'ปานกลาง',
  'admin.ai.long': 'ละเอียด',
  'admin.ai.focusAreas': 'พื้นที่โฟกัสการวิเคราะห์',
  'admin.ai.autoRating': 'การให้คะแนนอัตโนมัติ',
  'admin.ai.autoRatingDesc': 'ทุกการวิเคราะห์ได้รับการให้คะแนนอัตโนมัติ (ดี/ปานกลาง/แย่)',
  'admin.ai.showSources': 'แสดงแหล่งที่มา',
  'admin.ai.showSourcesDesc': 'การอ้างอิงถึงแหล่งข้อมูลและข้อมูลตลาดในการตอบสนอง',
  'admin.ai.hidePreview': 'ซ่อนตัวอย่าง',
  'admin.ai.showPreview': 'แสดงตัวอย่าง',
  'admin.ai.aiBehavior': 'พฤติกรรม AI',
  'admin.ai.length': 'ความยาว',
  'admin.ai.liveExample': 'ตัวอย่างสด',
  'admin.ai.testSettings': 'ทดสอบการตั้งค่าของคุณ',
  'admin.ai.selectExampleQuestion': 'เลือกคำถามตัวอย่าง:',
  'admin.ai.userAsks': 'ผู้ใช้ถาม:',
  'admin.ai.generating': 'AI กำลังสร้างการตอบสนอง...',
  'admin.ai.generateExample': 'สร้างการตอบสนองตัวอย่าง',
  'admin.ai.aiResponds': 'ผู้ช่วย AI ตอบสนอง:',
  'admin.ai.generateHint': 'คลิก "สร้างการตอบสนองตัวอย่าง" เพื่อดูว่า AI ตอบสนองอย่างไรกับการตั้งค่าของคุณ',
  'admin.ai.reset': 'รีเซ็ต',
  'admin.ai.saved': 'บันทึกแล้ว!',
  'admin.ai.saveSettings': 'บันทึกการตั้งค่า',

  // --- Table headers ---
  'admin.coupons.code': 'รหัส',
  'admin.coupons.credits': 'เครดิต',

  // --- AI Model Descriptions ---
  'admin.ai.model.standardDesc': 'การวิเคราะห์ที่สมดุลด้วยคุณภาพสูง ตัวเลือกที่ดีที่สุดสำหรับการประเมินช่องทางและการตรวจสอบไอเดียส่วนใหญ่',
  'admin.ai.model.preciseAnalyses': 'การวิเคราะห์ที่แม่นยำ',
  'admin.ai.model.bestBalance': 'ความสมดุลที่ดีที่สุด',
  'admin.ai.model.recommended': 'แนะนำ',
  'admin.ai.model.fastDesc': 'การตอบสนองที่รวดเร็วปานสายฟ้าสำหรับการตรวจสอบช่องทางด่วน การระดมสมองและการประเมินเบื้องต้น เหมาะที่สุดเมื่อความเร็วสำคัญ',
  'admin.ai.model.fast': 'รวดเร็ว',
  'admin.ai.model.fastestResponses': 'การตอบสนองที่เร็วที่สุด',
  'admin.ai.model.thinkingDesc': 'การวิเคราะห์เชิงลึกด้วยการคิดเชิงตรรกะขั้นสูง สำหรับการวิเคราะห์ตลาดที่ซับซ้อน การประเมินเชิงวิพากษ์และการวางแผนเชิงกลยุทธ์',
  'admin.ai.model.deepestAnalysis': 'การวิเคราะห์ที่ลึกที่สุด',
  'admin.ai.model.logicalThinking': 'การคิดเชิงตรรกะ',
  'admin.ai.model.strategy': 'กลยุทธ์',

  // --- AI Preset Names & Descriptions ---
  'admin.ai.preset.strict.name': 'การวิเคราะห์ที่เข้มงวด',
  'admin.ai.preset.strict.desc': 'มีวิจารณญาณ, ตามข้อเท็จจริง, ไม่มีการปรุงแต่ง เปิดเผยจุดอ่อนอย่างไร้ความปรานี',
  'admin.ai.preset.extreme.name': 'การวิเคราะห์ขั้นสุดขีด',
  'admin.ai.preset.extreme.desc': 'ความเข้มงวดสูงสุด คำวิจารณ์ที่ไร้ความปรานี โฟกัสสถานการณ์เลวร้ายที่สุด สำหรับการตรวจสอบความจริงที่หนักหน่วงเท่านั้น',
  'admin.ai.preset.professional.name': 'มืออาชีพ',
  'admin.ai.preset.professional.desc': 'เป็นกลาง, มีโครงสร้าง, สมดุล เหมือนที่ปรึกษาธุรกิจที่มีประสบการณ์',
  'admin.ai.preset.realistic.name': 'สมจริง',
  'admin.ai.preset.realistic.desc': 'ซื่อสัตย์และปฏิบัติได้จริง โฟกัสที่การนำไปปฏิบัติที่เป็นไปได้และข้อมูลตลาดจริง',
  'admin.ai.preset.creative.name': 'สร้างสรรค์และสร้างแรงบันดาลใจ',
  'admin.ai.preset.creative.desc': 'สร้างแรงบันดาลใจ, อุดมด้วยไอเดีย, เชิงบวก ค้นหาโอกาสและเส้นทางที่แหวกแนว',
  'admin.ai.preset.balanced.name': 'สมดุล',
  'admin.ai.preset.balanced.desc': 'ส่วนผสมที่ดีของคำวิจารณ์และแรงจูงใจ โหมดเริ่มต้น',
  'admin.ai.preset.investor.name': 'มุมมองนักลงทุน',
  'admin.ai.preset.investor.desc': 'เหมือน Venture Capitalist โฟกัสที่การขยายขนาด ROI และกลยุทธ์การออก',
  'admin.ai.preset.startup-coach.name': 'โค้ชสตาร์ทอัพ',
  'admin.ai.preset.startup-coach.desc': 'ที่ปรึกษาที่ปฏิบัติได้จริงสำหรับผู้ก่อตั้ง โฟกัสที่การนำไปใช้อย่างรวดเร็วและ MVP',
  'admin.ai.preset.market-researcher.name': 'นักวิจัยตลาด',
  'admin.ai.preset.market-researcher.desc': 'ขับเคลื่อนด้วยข้อมูลและวิเคราะห์ การวิเคราะห์ตลาดและการแข่งขันเชิงลึก',
  'admin.ai.preset.risk-analyst.name': 'นักวิเคราะห์ความเสี่ยง',
  'admin.ai.preset.risk-analyst.desc': 'โฟกัสที่ความเสี่ยงและสถานการณ์เลวร้ายที่สุด สำหรับการวางแผนที่สมจริง',

  // --- Focus Areas ---
  'admin.ai.focus.marktanalyse': 'การวิเคราะห์ตลาด',
  'admin.ai.focus.wettbewerb': 'การแข่งขัน',
  'admin.ai.focus.monetarisierung': 'การสร้างรายได้',
  'admin.ai.focus.risiken': 'ความเสี่ยง',
  'admin.ai.focus.finanzen': 'การเงิน',
  'admin.ai.focus.skalierung': 'การขยายขนาด',
  'admin.ai.focus.innovation': 'นวัตกรรม',
  'admin.ai.focus.trends': 'แนวโน้ม',
  'admin.ai.focus.differenzierung': 'ความแตกต่าง',
  'admin.ai.focus.umsetzung': 'การนำไปปฏิบัติ',
  'admin.ai.focus.zielgruppe': 'กลุ่มเป้าหมาย',
  'admin.ai.focus.marketing': 'การตลาด',

  // --- Tone Options ---
  'admin.ai.tone.direkt': 'ตรงไปตรงมาและรุนแรง',
  'admin.ai.tone.professionell': 'มืออาชีพและเป็นกลาง',
  'admin.ai.tone.ehrlich': 'ซื่อสัตย์และปฏิบัติได้จริง',
  'admin.ai.tone.motivierend': 'สร้างแรงบันดาลใจและเชิงบวก',
  'admin.ai.tone.freundlich': 'เป็นมิตรและให้การสนับสนุน',
  'admin.ai.tone.akademisch': 'วิชาการและวิเคราะห์',

  // --- Example Questions ---
  'admin.ai.question.niche': 'คุณแนะนำช่องทางที่ทำกำไรได้แบบไหน?',
  'admin.ai.question.evaluate': 'ให้คะแนนไอเดียของฉัน: แอพสำหรับเจ้าของสุนัข',
  'admin.ai.question.trends': 'แนวโน้มไหนที่มีศักยภาพในตอนนี้?',
  'admin.ai.question.sharpen': 'ฉันจะ sharpen ช่องทางของฉันได้อย่างไร?',

  'admin.ai.rec.bestCombination.title': '🏆 การรวมกันที่ดีที่สุด (2 Presets)',
  'admin.ai.rec.bestCombination.desc': 'มีวิจารณญาณแต่สร้างสรรค์ พร้อมขั้นตอนการดำเนินการที่เป็นรูปธรรม',
  'admin.ai.rec.bestCombination.useCase': 'แนะนำสำหรับการวิเคราะห์ส่วนใหญ่',

  'admin.ai.rec.balancedThree.title': '⚖️ สมดุล (3 Presets)',
  'admin.ai.rec.balancedThree.desc': 'มืออาชีพ, สมจริงและเป็นมิตรกับนักลงทุน',
  'admin.ai.rec.balancedThree.useCase': 'สำหรับการวิเคราะห์ธุรกิจที่ครอบคลุม',

  'admin.ai.rec.creativeDriven.title': '💡 สร้างสรรค์และสร้างแรงบันดาลใจ (2 Presets)',
  'admin.ai.rec.creativeDriven.desc': 'สร้างแรงบันดาลใจพร้อมเคล็ดลับการนำไปปฏิบัติ',
  'admin.ai.rec.creativeDriven.useCase': 'สำหรับการสร้างไอเดียและการระดมสมอง',

  'pdf.rating.good': 'Good',
  'pdf.rating.bad': 'Bad',
  'pdf.rating.medium': 'Medium',
  'pdf.header.subtitle': 'Analysis View',
  'pdf.footer.tagline': 'AI-Powered Niche Validation',
  'pdf.footer.page': 'Page',
  'pdf.benchmark.title': 'INDUSTRY BENCHMARK',
  'pdf.benchmark.yourScore': 'Your Score',
  'pdf.benchmark.top10': 'Top 10%: 85+',
  'pdf.marketAnalysis.title': 'MARKET ANALYSIS',
  'pdf.summary.title': 'SUMMARY',
  'pdf.structuredSummary.verdict': 'VERDICT',
  'pdf.disclaimer.body': 'This report was generated by an AI model and is intended for informational purposes only. It does not constitute financial, legal, tax, or investment advice. Market data, ratings, and projections are AI-generated estimates and may be incomplete or inaccurate. Please verify all information independently and consult qualified professionals before making any business or investment decisions. IdeaVerdict assumes no liability for actions taken based on this report.',
  'pdf.disclaimer.title': 'IMPORTANT NOTICE',
  'pdf.closing.title': 'Generated by IdeaVerdict',
  'pdf.closing.subtitle': 'AI-Powered Niche Validation  |  Comprehensive Market Intelligence',
  'history.swot.title': 'SWOT Analysis',
  'history.swot.strengths': 'Strengths',
  'history.swot.weaknesses': 'Weaknesses',
  'history.swot.opportunities': 'Opportunities',
  'history.swot.risks': 'Risks',
  'history.sections.recommendations': 'Recommendations',
  'history.sections.marketAnalysis': 'Competitive Analysis',
  'history.sections.microAngles': 'Micro-Niche Angles',
  'history.sections.improvements': 'Improvement Suggestions',
  'history.sections.alternatives': 'Alternative Niches',
  'history.sections.structuredSummary': 'Structured Summary (Builder)',
  'history.structuredSummary.strengths': 'Top Strengths',
  'history.structuredSummary.risks': 'Top Risks',
  'history.structuredSummary.actions': 'Next Steps',
  'history.sections.developerBriefing': 'Developer Briefing (Builder)',
  'history.sections.conversation': 'Conversation History',
  'history.conversation.user': 'User',
  'history.conversation.assistant': 'IdeaVerdict',
  'history.conversation.structuredResult': 'Structured Result',
  'admin.tabs.usage': 'Usage',
  'admin.usage.title': 'AI Usage & Cost Analysis',
  'admin.usage.refresh': 'Refresh data',
  'admin.usage.requests': 'Requests',
  'admin.usage.users': 'Users',
  'admin.usage.totalTokens': 'Total Tokens',
  'admin.usage.apiCosts': 'API Costs',
  'admin.usage.revenue': 'Revenue',
  'admin.usage.margin': 'Margin',
  'admin.usage.byModel': 'By Model',
  'admin.usage.allModels': 'All Models',
  'admin.usage.searchEmail': 'Search by email address...',
  'admin.usage.perPage': 'Per page:',
  'admin.usage.loading': 'Loading usage data...',
  'admin.usage.noEntries': 'No entries found for current filters.',
  'admin.usage.time': 'Time',
  'admin.usage.user': 'User',
  'admin.usage.model': 'Model',
  'admin.usage.credits': 'Credits',
  'admin.usage.tokens': 'Tokens',
  'admin.usage.duration': 'Duration',
  'admin.usage.details': 'Details',
  'admin.usage.showing': 'Showing',
  'admin.usage.of': 'of',
  'admin.usage.entries': 'entries',
  'admin.usage.firstPage': 'First Page',
  'admin.usage.prevPage': 'Previous',
  'admin.usage.page': 'Page',
  'admin.usage.nextPage': 'Next',
  'admin.usage.lastPage': 'Last Page',
  'admin.usage.requestDetails': 'Request Details',
  'admin.usage.close': 'Close',
  'admin.usage.loadingDetails': 'Loading details...',
  'admin.usage.inputTokens': 'Input Tokens',
  'admin.usage.outputTokens': 'Output Tokens',
  'admin.usage.providerCost': 'Provider Cost',
  'admin.usage.providerBreakdown': 'Provider Breakdown',
  'admin.usage.fullResponseData': 'Full Response Data',
  'admin.usage.entryNotFound': 'This entry could not be loaded.',
  'admin.usage.today': 'Today',
  'admin.usage.last7d': 'Last 7 Days',
  'admin.usage.last30d': 'Last 30 Days',
  'admin.usage.allTime': 'All Time',
  'admin.ai.fallbackModel': 'Fallback Model',
  'admin.ai.systemPrompts': 'System Prompts',
  'admin.ai.fallbackModelDesc': 'Used when the primary model fails or returns invalid output',
  'admin.ai.systemPromptsDesc': 'Read-only view of what each model receives as instructions',
  'admin.ai.provider': 'Provider',
  'admin.ai.modelId': 'Model ID',
  'admin.ai.maxTokens': 'Max Tokens',
  'admin.ai.temperature': 'Temperature',
  'admin.ai.thinkingBudget': 'Thinking Budget',
  'admin.ai.supportsThinking': 'Supports Thinking',
  'admin.ai.displayName': 'Display Name',
  'admin.ai.precise': 'Precise',
  'admin.ai.creativeTemp': 'Creative',

  // Header + Sidebar (auto-added by rebrand)
  'header.openMenu': 'เปิดเมนู',
  'header.home': 'หน้าแรก',
  'header.notifications': 'การแจ้งเตือน',
  'header.settings': 'การตั้งค่า',
  'header.profile': 'โปรไฟล์',
  'sidebar.collapse': 'ย่อแถบด้านข้าง',
  'sidebar.expand': 'ขยายแถบด้านข้าง',
  'sidebar.close': 'ปิดเมนู',
  'sidebar.plan': 'แพ็คเกจ',
  'sidebar.backToWebsite': 'กลับไปที่เว็บไซต์',

  // Legal — Imprint (auto-added)
  'legal.imprint.title': 'Imprint',
  'legal.imprint.company': 'Scherbius Technology',
  'legal.imprint.location': 'Dubai, United Arab Emirates (UAE)',
  'legal.imprint.seatLabel': 'Registered office',
  'legal.imprint.seatBody': 'Dubai, United Arab Emirates',
  'legal.imprint.contactLabel': 'Contact',
  'legal.imprint.contactBody': 'Contact details are provided at the sole discretion of Scherbius Technology.',
  'legal.imprint.representationLabel': 'Legal representation',
  'legal.imprint.representationBody': 'Scherbius Technology is represented by its legal representatives in accordance with the laws of the United Arab Emirates.',
  'legal.imprint.contentLiabilityLabel': 'Liability for content',
  'legal.imprint.contentLiabilityBody': 'The contents of this website have been created with the greatest possible care.\nHowever, Scherbius Technology assumes no liability for the accuracy, completeness or timeliness of the content.',
  'legal.imprint.linksLiabilityLabel': 'Liability for external links',
  'legal.imprint.linksLiabilityBody': 'This website may contain links to external third-party websites whose content we have no control over.\nNo liability is assumed for these external contents.',
  'legal.imprint.lawLabel': 'Applicable law',
  'legal.imprint.lawBody': 'The laws of the United Arab Emirates apply exclusively.\nPlace of jurisdiction is Dubai, UAE.',

  // Overview page (auto-added)
  'overview.greeting': 'ยินดีต้อนรับกลับ',
  'overview.greetingSub': 'นี่คือสิ่งที่กำลังเกิดขึ้นบนโต๊ะคำตัดสินของคุณ',
  'overview.heroCta': 'คำตัดสินใหม่',
  'overview.currentPlan': 'แพ็คเกจปัจจุบัน',
  'overview.creditsLabel': 'เครดิต',
  'overview.usedThisCycle': 'ใช้ในรอบนี้',
  'overview.resetsOn': 'รีเซ็ตวันที่',
  'overview.unlimitedTitle': 'ไม่จำกัด',
  'overview.builderPerk': 'คุณมีสิทธิ์เข้าถึง Builder เต็มรูปแบบ — ไม่มีขีดจำกัด',
  'overview.runOne': 'รันคำตัดสิน',
  'overview.lastVerdicts': '5 คำตัดสินล่าสุดของคุณ',
  'overview.noActivity': 'ยังไม่มีคำตัดสิน — เริ่มการวิเคราะห์แรกของคุณ',
  'overview.tipTitle': 'เคล็ดลับ',
  'overview.tipBody': 'ทดสอบไอเดียในสองภาษา — หากคำตัดสินอ่อนลงในภาษาหนึ่ง สมมติฐานของคุณเป็นแบบท้องถิ่น ไม่ใช่สากล',
  'onboard.skip': "ข้าม",
  'onboard.cta.next': "ถัดไป",
  'onboard.cta.start': "เริ่มต้นใช้งาน",
  'onboard.s1.title': "ยินดีต้อนรับสู่ IdeaVerdict",
  'onboard.s1.body': "คำตัดสินจาก AI ต่อไอเดียธุรกิจของคุณ — ก่อนที่คุณจะลงมือสร้าง",
  'onboard.s2.title': "คำตัดสินที่ตรงไปตรงมาอย่างโหดร้าย",
  'onboard.s2.body': "ไม่มีการโฆษณาเกินจริง ไม่มีคำเยินยอ มีแต่ข้อมูลตลาดจริง คู่แข่งจริง และความเสี่ยงจริง",
  'onboard.s3.title': "Builder Report ในรูปแบบ PDF",
  'onboard.s3.body': "สร้างรายงานความยาว 25–75 หน้า พร้อมสถาปัตยกรรมที่สมบูรณ์ การเงิน และกลยุทธ์การเข้าสู่ตลาด",
  'onboard.s4.title': "เมื่อคุณพร้อมแล้ว",
  'onboard.s4.body': "สมัครสมาชิกและรับคำตัดสินแรกของคุณภายในหนึ่งนาที",
  'builderReport.title': "Building your Builder Report",
  'builderReport.subtitle': "Comprehensive analysis + developer briefing — downloads as PDF when ready.",
  'builderReport.idea': "Your idea",
  'builderReport.ideaPlaceholder': "Describe your business idea (or leave blank to use the last idea you discussed)…",
  'builderReport.cta': "Generate Report",
  'builderReport.credits': "credits",
  'builderReport.deductedNow': "Deducted on success",
  'builderReport.dontClose': "Please don't close this window — generation can take 30-90 seconds.",
  'builderReport.done': "PDF downloaded — check your downloads folder.",
  'builderReport.failed': "การสร้างล้มเหลว",
  'builderReport.close': "Close",
  'builderReport.cancel': "Cancel",
  'builderReport.running': "Generating…",
  'builderReport.retry': "Try again",
  'builderReport.unknownError': "Generation failed. Your credits should be refunded.",
  'builderReport.signInRequired': "You must be signed in to generate a report.",
  'builderReport.ideaRequired': "Please describe your idea so the AI has something to analyze.",
  'builderReport.fromChat': "From your current conversation",
  'builderReport.noIdeaDetected': "Using the idea we have been discussing.",
  'builderReport.contextHint': "The AI will use everything from this chat — no new idea will be invented.",
  'builderReport.step.core': "Generating core analysis",
  'builderReport.step.market': "Adding extended market analysis",
  'builderReport.step.tech': "Adding technical architecture",
  'builderReport.step.financials': "Adding financial models",
  'builderReport.step.compet': "Adding competitive intelligence",
  'builderReport.step.gtm': "Adding go-to-market strategy",
  'builderReport.step.deepdive': "Adding industry deep-dive",
  'builderReport.step.pdf': "Compiling the PDF…",
  'briefing.title': "Building your Developer Briefing",
  'briefing.subtitle': "11-section technical briefing — downloads as PDF when ready.",
  'briefing.ideaPlaceholder': "Describe your business idea (or leave blank to use the last idea you discussed)…",
  'briefing.cta': "Generate Briefing",
  'briefing.step.core': "Generating developer briefing",
  'briefing.step.pdf': "Compiling the PDF…",
  'pricing.gold.name': "Gold",
  'pricing.gold.description': "เครดิตมากขึ้น + รายงาน 50 หน้า",
  'pricing.gold.credits': "12,500 เครดิตต่อเดือน",
  'pricing.platinum.name': "Platinum",
  'pricing.platinum.description': "ระดับสูงสุด + รายงาน 75 หน้า",
  'pricing.platinum.credits': "15,000 เครดิตต่อเดือน",
  // ─── Auto-backfilled from EN (2026-05-13) ───
  // These are English fallbacks for keys that hadn't been translated to
  // "th" yet. Replace with native translations as needed.
  'nav.slogan': 'An AI verdict on your business idea — before you build',
  'chat.creditsPerQuestion': 'Credits/question',
  'chat.notEnoughCreditsTitle': 'Not enough credits',
  'chat.notEnoughCreditsDesc': 'You need at least {{cost}} credits per question.',
  'chat.creditsRunningLow': 'Credits running low',
  'chat.questionsRemaining': '{{count}} questions remaining.',
  'chat.noCreditsModalTitle': 'Not enough credits',
  'chat.noCreditsModalDesc': 'You need at least <1>{{cost}} credits</1> per question. Your current balance: <2>{{balance}} credits</2>',
  'chat.currentPlan': 'Current plan',
  'chat.close': 'Close',
  'chat.upgrade': 'Upgrade',
  'sub.manageBilling': 'Manage billing',
  'credits.topup.buyMore': 'Buy more credits',
  'trial.creditsLow': "Only {{count}} Credits left!",
  'trial.upgradeNow': "อัปเกรดเลย →",
  'trial.upgradeNowArrow': "Upgrade now →",
  'trial.creditsExhausted': "Credits exhausted",
  'trial.upgradeForUnlimited': "Upgrade for unlimited use",
  'trial.noCreditsPlaceholder': "No credits left…",
  'hero.badgeHonest': "ตรงไปตรงมาอย่างโหดร้าย",
  'hero.badge60sec': "คำตัดสินใน 60 วินาที",
  'hero.badge20Lang': "กว่า 20 ภาษา",
  'hero.widget.label': "คำตัดสินไอเดีย",
  'hero.widget.passed': "ผ่าน",
  'hero.widget.demoIdea': "ติวเตอร์ AI สำหรับนักศึกษาแพทย์",
  'hero.widget.market': "ตลาด",
  'hero.widget.demand': "อุปสงค์",
  'hero.widget.competition': "การแข่งขัน",
  'hero.widget.verdictReady': "คำตัดสินพร้อม · 47 วินาที",
  'hero.widget.riskFlagged': "ระบุความเสี่ยงแล้ว",
  'hero.widget.crowdedMarket': "Crowded market · 4 incumbents",
  'hero.widget.suggestedPivot': "การปรับทิศทางที่แนะนำ",
  'hero.widget.nicheBySpecialty': "Niche by specialty",
  'hero.widget.feasibilityGain': "+38% feasibility",
  'hero.widget.analysisDone': "การวิเคราะห์เสร็จสิ้น",
  'hero.widget.metrics56': "5 of 6 metrics",
  'hero.stats.verdictSpeed': "Verdict speed",
  'cta.badge': "คำตัดสินใน 60 วินาที",
  'cta.subtitleEnd': "โดยไม่ต้องเดา",
  'cta.signinPrompt': "มีบัญชีอยู่แล้ว? ลงชื่อเข้าใช้",
  'cta.trustTrial': "ทดลองใช้ฟรี 7 วัน",
  'cta.trustNoCard': "ไม่ต้องใช้บัตร",
  'cta.trustCancel': "ยกเลิกได้ทุกเมื่อ",
  'footer.themeLabel': "ธีม:",
  'footer.lightMode': "โหมดสว่าง",
  'footer.darkMode': "โหมดมืด",
  'footer.sectionProduct': "ผลิตภัณฑ์",
  'footer.sectionLegal': "กฎหมาย",
  'nav.switchLight': "สลับเป็นโหมดสว่าง",
  'nav.switchDark': "สลับเป็นโหมดมืด",
  'features.badge': "ทำไมต้อง IdeaVerdict",
  'features.mainFeatureLabel': "พาดหัว",
  'faq.badge': "คำถามที่พบบ่อย",
  'trial.lowCredits': "เหลือเครดิตเพียง {credits} เครดิตเท่านั้น!",
  'trial.outOfCredits': "เครดิตหมดแล้ว",
  'trial.outOfCreditsDesc': "อัปเกรดเพื่อรับคำตัดสินต่อไป",
  'trial.viewPlans': "ดูแพ็กเกจ",
  'trial.tryDemo': "ลองใช้เดโม",
  'hero.widget.crowded': "ตลาดแออัด · 4 รายเดิม",
  'hero.widget.nicheBySpec': "เจาะตลาดเฉพาะตามสาขา",
  'hero.widget.feasibilityUp': "ความเป็นไปได้ +38%",
  'hero.widget.fiveOfSix': "5 จาก 6 ตัวชี้วัด",
  'builderReport.modalTitle': "Builder Report",
  'builderReport.modalSubtitle': "สร้าง PDF ที่ครอบคลุมสำหรับไอเดียของคุณ",
  'builderReport.formatLabel': "รูปแบบรายงาน",
  'builderReport.formatStandard': "รายงานมาตรฐาน",
  'builderReport.formatExec': "บทสรุปผู้บริหาร",
  'builderReport.toneLabel': "น้ำเสียง",
  'builderReport.toneProfessional': "มืออาชีพ",
  'builderReport.toneCasual': "เป็นกันเอง",
  'builderReport.toneTechnical': "เชิงเทคนิค",
  'builderReport.sectionsLabel': "หัวข้อที่จะรวม",
  'builderReport.sectionMarket': "การวิเคราะห์ตลาด",
  'builderReport.sectionCompetition': "ภาพรวมการแข่งขัน",
  'builderReport.sectionFinancial': "แบบจำลองทางการเงิน",
  'builderReport.sectionArchitecture': "สถาปัตยกรรมทางเทคนิค",
  'builderReport.sectionGTM': "แผนการเข้าสู่ตลาด",
  'builderReport.sectionRisks': "ทะเบียนความเสี่ยง",
  'builderReport.sectionRoadmap': "แผนพัฒนาผลิตภัณฑ์",
  'builderReport.sectionTeam': "แผนทีมและการจ้างงาน",
  'builderReport.actionGenerate': "สร้างรายงาน",
  'builderReport.actionCancel': "ยกเลิก",
  'builderReport.actionDownload': "ดาวน์โหลด PDF",
  'builderReport.statusGenerating': "กำลังสร้างรายงานของคุณ…",
  'builderReport.statusComplete': "รายงานพร้อมแล้ว",
  'builderReport.statusError': "มีบางอย่างผิดพลาด ลองใหม่อีกครั้ง",
  'builderReport.creditsRequired': "การดำเนินการนี้จะใช้ {credits} เครดิต",
  'builderReport.pageCount': "{pages} หน้า",
  'builderReport.tip1': "เคล็ดลับ: ระบุลูกค้าเป้าหมายให้ชัดเจนเพื่อการวิเคราะห์ที่แม่นยำขึ้น",
  'builderReport.tip2': "เคล็ดลับ: ใส่ตัวเลขรายได้เริ่มต้นด้วยถ้ามี",
  'builderReport.tip3': "เคล็ดลับ: ระบุเทคโนโลยีที่คุณชอบใช้ถ้ามี",
  'builderReport.errorNotEnough': "คุณมีเครดิตไม่พอสำหรับรายงานนี้",
  'builderReport.errorUpgrade': "อัปเกรดเป็นแพ็กเกจที่สูงขึ้น",
  'builderReport.errorTryStandard': "ลองใช้รายงานมาตรฐานแทน",
  'builderReport.success': "Builder Report ของคุณพร้อมแล้ว",
  'builderReport.previewBadge': "ตัวอย่าง",
  'builderReport.previewNote': "นี่คือตัวอย่าง สร้าง PDF เต็มรูปแบบเพื่อดูทุกหัวข้อ",
  'builderReport.includesLabel': "ประกอบด้วย",
  'builderReport.pagesIncluded': "การวิเคราะห์ {pages} หน้า",
  'builderReport.estimatedTime': "เวลาโดยประมาณ: {minutes} นาที",
  'builderReport.fullReport': "รายงานเต็มรูปแบบ",
  'builderReport.execSummary': "บทสรุปผู้บริหาร",
  'chatError.planRestriction': "ฟีเจอร์นี้ต้องใช้แผนที่สูงขึ้น",
  'chatError.creditDeduction': "การประมวลผลการชำระเงินล้มเหลว โปรดลองอีกครั้ง",
  'chatError.aiService': "บริการ AI ไม่พร้อมใช้งานชั่วคราว เครดิตของคุณยังไม่ถูกหัก โปรดลองอีกครั้ง",
  'chatError.parseError': "ได้รับรูปแบบการตอบกลับที่ไม่คาดคิด โปรดลองอีกครั้ง",
  'chatError.sessionExpired': "เซสชันของคุณหมดอายุแล้ว โปรดเข้าสู่ระบบอีกครั้ง",
  'chatError.timeout': "คำขอใช้เวลานานเกินไป โปรดลองอีกครั้ง",
  'chatError.generic': "ไม่สามารถรับการตอบกลับได้ โปรดลองอีกครั้ง",
  'pricing.builder.report': "Builder Report 25 หน้า",
  'pricing.gold.report': "Builder Report 50 หน้า",
  'pricing.platinum.report': "Builder Report 75 หน้า",
  'auth.bestValue': "คุ้มค่าที่สุด",
  'auth.elite': "อีลีท",
  'builderReport.friendlyError': "เราไม่สามารถสร้างรายงานของคุณให้เสร็จในครั้งนี้ เครดิตของคุณยังไม่ถูกหัก โปรดลองอีกครั้งในอีกสักครู่",
  'builderReport.persistHint': "หากปัญหานี้ยังคงเกิดขึ้น โปรดติดต่อ support@ideaverdict.ai",
};
